export const namibiaMunicipality = [
  { name: "Arandis", value: "001" },
    { name: "Daures", value: "002" },
    { name: "Karibib", value: "003" },
    { name: "Omaruru", value: "004" },
    { name: "Swakopmund", value: "005" },
    { name: "Walvis Bay Rural", value: "006" },
    { name: "Walvis Bay Urban", value: "007" },
    { name: "Aranos", value: "008" },
    { name: "Daweb", value: "009" },
    { name: "Gibeon", value: "010" },
    { name: "Mariental Rural", value: "011" },
    { name: "Mariental Urban", value: "012" },
    { name: "Rehoboth Rural", value: "013" },
    { name: "Rehoboth Urban East", value: "014" },
    { name: "Rehoboth Urban West", value: "015" },
    { name: "Mashare", value: "016" },
    { name: "Mukwe", value: "017" },
    { name: "Ndiyona", value: "018" },
    { name: "Ndonga Linena", value: "019" },
    { name: "Rundu Rural", value: "020" },
    { name: "Rundu Urban", value: "021" },
    { name: "Kapako", value: "022" },
    { name: "Mankumpi", value: "023" },
    { name: "Mpungu", value: "024" },
    { name: "Musese", value: "025" },
    { name: "Ncamasoro", value: "026" },
    { name: "Ncamangoro", value: "026" },
    { name: "Ncumkuru", value: "027" },
    { name: "Tondoro", value: "029" },
    { name: "John Pandeni", value: "030" },
    { name: "Katutura Central", value: "031" },
    { name: "Katutura East", value: "032" },
    { name: "Khomasdal", value: "033" },
    { name: "Moses ǁGaroëb", value: "034" },
    { name: "Samora Machel", value: "035" },
    { name: "Tobias Hainyeko", value: "036" },
    { name: "Windhoek East", value: "037" },
    { name: "Windhoek Rural", value: "038" },
    { name: "Windhoek West", value: "039" },
    { name: "Epupa", value: "040" },
    { name: "Kamanjab", value: "041" },
    { name: "Khorixas", value: "042" },
    { name: "Opuwo Rural", value: "043" },
    { name: "Opuwo Urban", value: "044" },
    { name: "Epukiro", value: "060" },
    { name: "Gobabis", value: "061" },
    { name: "Kalahari", value: "062" },
    { name: "Otjinene", value: "063" },
    { name: "Otjombinde", value: "064" },
    { name: "Okorukambe", value: "065" },
    { name: "Endola", value: "048" },
    { name: "Engela", value: "049" },
    { name: "Epembe", value: "050" },
    { name: "Ohangwena", value: "051" },
    { name: "Okongo", value: "052" },
    { name: "Omulonga", value: "053" },
    { name: "Omundaungilo", value: "054" },
    { name: "Ondobe", value: "055" },
    { name: "Ongenga", value: "056" },
    { name: "Oshikango", value: "057" },
    { name: "Oshikunde", value: "058" },
    { name: "Eengodi", value: "089" },
    { name: "Guinas", value: "090" },
    { name: "Nehale lyaMpingana", value: "091" },
    { name: "Okankolo", value: "092" },
    { name: "Olukonda", value: "093" },
    { name: "Omuthiyagwiipundi", value: "095" },
    { name: "Onayena", value: "096" },
    { name: "Oniipa", value: "097" },
    { name: "Onyaanya", value: "098" },
    { name: "Anamulenge", value: "066" },
    { name: "Elim", value: "067" },
    { name: "Etayi", value: "068" },
    { name: "Ogongo", value: "069" },
    { name: "Okahao", value: "070" },
    { name: "Okalongo", value: "071" },
    { name: "Onesi", value: "072" },
    { name: "Oshikuku", value: "073" },
    { name: "Otamanzi", value: "074" },
    { name: "Outapi", value: "075" },
    { name: "Ruacana", value: "076" },
    { name: "Tsandi", value: "077" },
    { name: "Okaku", value: "078" },
    { name: "Okatana", value: "079" },
    { name: "Okatjali", value: "080" },
    { name: "Ompundja", value: "081" },
    { name: "Ondangwa Rural", value: "082" },
    { name: "Ondangwa Urban", value: "083" },
    { name: "Ongwediva", value: "084" },
    { name: "Oshakati East", value: "085" },
    { name: "Oshakati West", value: "086" },
    { name: "Uukwiyuushona", value: "087" },
    { name: "Uuvudhiya", value: "088" },
    { name: "Grootfontein", value: "100" },
    { name: "Okahandja", value: "101" },
    { name: "Okakarara", value: "102" },
    { name: "Omatako", value: "103" },
    { name: "Otavi", value: "104" },
    { name: "Otjiwarongo", value: "105" },
    { name: "Judea Lyaboloma", value: "107" },
    { name: "Kabbe North", value: "108" },
    { name: "Kabbe South", value: "109" },
    { name: "Katima Mulilo Rural", value: "110" },
    { name: "Katima Mulilo Urban", value: "111" },
    { name: "Kongola", value: "112" },
    { name: "Linyanti", value: "113" },
    { name: "Sibinda", value: "114" },
    { name: "Berseba", value: "115" },
    { name: "Karasburg East", value: "116" },
    { name: "Karasburg West", value: "117" },
    { name: "Keetmanshoop Rural", value: "118" },
    { name: "Keetmanshoop Urban", value: "119" },
    { name: "ǃNamiǂNûs", value: "120" },
    { name: "Oranjemund", value: "121" }

];
export const   dropdownItems = {
 
  REGION: [
    { name: "Gauteng", value: "01" },
  { name: "Eastern Cape", value: "02" },
  { name: "Limpopo", value: "03" },
  { name: "KwaZulu-Natal", value: "04" },
  { name: "Mpumalanga", value: "05" },
  { name: "Western Cape", value: "06" },
  { name: "North West", value: "07"},
  { name: "Northern Cape", value: "08" },
  { name: "Free State", value: "09" }
  ],
  

DISTRICT: [
    { name: "City of Johannesburg", value: "001" },
    { name: "City of Tshwane", value: "002" },
    { name: "Ekurhuleni", value: "003" },
    { name: "Sedibeng", value: "004" },
    { name: "West Rand", value: "005" },
    { name: "Emfuleni", value: "006" },
    { name: "Lesedi Merafong City", value: "007" },
    { name: "Midvaal", value: "009" },
    { name: "Mogale City", value: "010" },
    { name: "Randfontein", value: "011" },
    { name: "Westonaria", value: "012" },
    { name: "Buffalo City Metropolitan", value: "013" },
    { name: "Nelson Mandela Bay", value: "014" },
    { name: "Alfred Nzo District", value: "015" },
    { name: "Amathole District", value: "016" },
    { name: "Cacadu District", value: "018" },
    { name: "Chris Hani District", value: "019" },
    { name: "Joe Gqabi", value: "020" },
    { name: "OR Tambo District", value: "022" },
    { name: "Amahlathi", value: "023" },
    { name: "Baviaans", value: "024" },
    { name: "Blue Crane Route", value: "025" },
    { name: "Buffalo City", value: "026" },
    { name: "Camdeboo", value: "027" },
    { name: "Elundini", value: "028" },
    { name: "Emalahleni", value: "029" },
    { name: "Engcobo", value: "030" },
    { name: "Gariep", value: "031" },
    { name: "Great Kei", value: "032" },
    { name: "Ikwezi", value: "033" },
    { name: "Ingquza Hill", value: "034" },
    { name: "Inkwanca", value: "035" },
    { name: "Intsika Yethu", value: "036" },
    { name: "Inxuba Yethemba", value: "037" },
    { name: "King Sabata Dalindyebo", value: "038" },
    { name: "Kou-Kamma", value: "039" },
    { name: "Kouga", value: "040" },
    { name: "Lukhanji", value: "041" },
    { name: "Makana", value: "042" },
    { name: "Maletswai", value: "043" },
    { name: "Matatiele", value: "044" },
    { name: "Mbhashe", value: "045" },
    { name: "Mbizana", value: "046" },
    { name: "Mhlontlo", value: "047" },
    { name: "Mnquma Local", value: "048" },
    { name: "Ndlambe Local", value: "049" },
    { name: "Ngqushwa", value: "050" },
    { name: "Nkonkobe", value: "051" },
    { name: "Ntabankulu", value: "052" },
    { name: "Nxuba Local", value: "053" },
    { name: "Nyandeni", value: "054" },
    { name: "Port St Johns", value: "055" },
    { name: "Sakhisizwe", value: "056" },
    { name: "Senqu Local", value: "057" },
    { name: "Sundays River Valley", value: "058" },
    { name: "Tsolwana Local", value: "059" },
    { name: "Umzimvubu", value: "060" },
    { name: "Capricorn", value: "061" },
    { name: "Mopani", value: "062" },
    { name: "Sekhukhune", value: "063" },
    { name: "Vhembe", value: "064" },
    { name: "Waterberg", value: "065" },
    { name: "Aganang", value: "066" },
    { name: "Ba-Phalaborwa", value: "067" },
    { name: "Bela-Bela", value: "068" },
    { name: "Blouberg", value: "069" },
    { name: "Elias Motsoaledi", value: "070" },
    { name: "Ephraim Mogale", value: "071" },
    { name: "Fetakgomo", value: "072" },
    { name: "Greater Giyani", value: "073" },
    { name: "Greater Letaba", value: "074" },
    { name: "Greater Tubatse", value: "075" },
    { name: "Greater Tzaneen", value: "076" },
    { name: "Lepelle-Nkumpi", value: "077" },
    { name: "Lephalale", value: "078" },
    { name: "Makhado", value: "079" },
    { name: "Makhuduthamaga", value: "080" },
    { name: "Maruleng", value: "081" },
    { name: "Modimolle", value: "082" },
    { name: "Mogalakwena", value: "083" },
    { name: "Molemole", value: "084" },
    { name: "Mookgophong", value: "085" },
    { name: "Musina", value: "086" },
    { name: "Mutale", value: "087" },
    { name: "Polokwane", value: "088" },
    { name: "Thabazimbi", value: "089" },
    { name: "Thulamela", value: "090" },
    { name: "eThekwini", value: "091" },
    { name: "Amajuba", value: "092" },
    { name: "iLembe", value: "094" },
    { name: "Sisonke", value: "095" },
    { name: "Ugu", value: "096" },
    { name: "uMkhanyakude", value: "098" },
    { name: "uMzinyathi", value: "099" },
    { name: "uThukela", value: "100" },
    { name: "uThungulu", value: "101" },
    { name: "Zululand", value: "102" },
    { name: "Abaqulusi", value: "103" },
    { name: "Dannhauser", value: "104" },
    { name: "eDumbe", value: "105" },
    { name: "eMadlangeni", value: "106" },
    { name: "Emnambithi/Ladysmith", value: "107" },
    { name: "Endumeni Local", value: "108" },
    { name: "Ezingoleni", value: "109" },
    { name: "Greater Kokstad", value: "110" },
    { name: "Hibiscus Coast", value: "111" },
    { name: "Hlabisa", value: "112" },
    { name: "Imbabazane", value: "113" },
    { name: "Impendle", value: "114" },
    { name: "Indaka", value: "115" },
    { name: "Ingwe", value: "116" },
    { name: "Jozini", value: "117" },
    { name: "KwaDukuza", value: "118" },
    { name: "KwaSani", value: "119" },
    { name: "Mandeni", value: "120" },
    { name: "Maphumulo", value: "121" },
    { name: "Mbonambi", value: "122" },
    { name: "Mkhambathini", value: "123" },
    { name: "Mpofana", value: "124" },
    { name: "Msinga", value: "125" },
    { name: "Mthonjaneni", value: "127" },
    { name: "Mtubatuba", value: "128" },
    { name: "Ndwedwe", value: "129" },
    { name: "Newcastle", value: "130" },
    { name: "Nkandla", value: "131" },
    { name: "Nongoma", value: "132" },
    { name: "Nquthu", value: "133" },
    { name: "Ntambanana", value: "134" },
    { name: "Okhahlamba", value: "135" },
    { name: "Richmond", value: "136" },
    { name: "The Big Five False Bay", value: "137" },
    { name: "Ubuhlebezwe", value: "138" },
    { name: "Ulundi", value: "139" },
    { name: "Umdoni", value: "140" },
    { name: "uMhlabuyalingana", value: "141" },
    { name: "uMhlathuze", value: "142" },
    { name: "uMlalazi", value: "143" },
    { name: "uMngeni", value: "144" },
    { name: "uMshwathi", value: "145" },
    { name: "Umtshezi", value: "146" },
    { name: "uMuziwabantu", value: "147" },
    { name: "Umvoti", value: "148" },
    { name: "Umzimkhulu", value: "149" },
    { name: "Umzumbe", value: "150" },
    { name: "uPhongolo", value: "151" },
    { name: "Vulamehlo", value: "152" },
    { name: "Ehlanzeni", value: "153" },
    { name: "Gert Sibande", value: "154" },
    { name: "Nkangala", value: "155" },
    { name: "Albert Luthuli", value: "156" },
    { name: "Bushbuckridge", value: "157" },
    { name: "Dipaleseng", value: "158" },
    { name: "Dr JS Moroka", value: "159" },
    { name: "Emakhazeni", value: "160" },
    { name: "Emalahleni", value: "161" },
    { name: "Lekwa", value: "163" },
    { name: "Mbombela", value: "164" },
    { name: "Mkhondo", value: "165" },
    { name: "Msukaligwa", value: "166" },
    { name: "Nkomazi", value: "167" },
    { name: "Pixley Ka Seme", value: "168" },
    { name: "Steve Tshwete", value: "169" },
    { name: "Thaba Chweu", value: "170" },
    { name: "Thembisile Hani", value: "171" },
    { name: "Umjindi", value: "172" },
    { name: "Victor Khanye", value: "173" },
    { name: "City of Cape Town", value: "174" },
    { name: "Cape Winelands", value: "175" },
    { name: "Central Karoo", value: "176" },
    { name: "Eden", value: "177" },
    { name: "Overberg", value: "178" },
    { name: "West Coast", value: "179" },
    { name: "Beaufort West", value: "180" },
    { name: "Bergrivier", value: "181" },
    { name: "Bitou", value: "182" },
    { name: "Breede Valley", value: "183" },
    { name: "Cape Agulhas", value: "184" },
    { name: "Cederberg", value: "185" },
    { name: "Drakenstein", value: "186" },
    { name: "George", value: "187" },
    { name: "Hessequa", value: "188" },
    { name: "Kannaland", value: "189" },
    { name: "Knysna", value: "190" },
    { name: "Laingsburg", value: "191" },
    { name: "Langeberg", value: "192" },
    { name: "Matzikama", value: "193" },
    { name: "Mossel Bay", value: "194" },
    { name: "Oudtshoorn", value: "195" },
    { name: "Overstrand", value: "196" },
    { name: "Prince Albert", value: "197" },
    { name: "Saldanha Bay", value: "198" },
    { name: "Stellenbosch", value: "199" },
    { name: "Swartland", value: "200" },
    { name: "Swellendam", value: "201" },
    { name: "Theewaterskloof", value: "202" },
    { name: "Witzenberg", value: "203" },
    { name: "Bojanala Platinum", value: "204" },
    { name: "Dr Kenneth Kaunda", value: "205" },
    { name: "Dr Ruth Segomotsi Mompati", value: "206" },
    { name: "Ngaka Modiri Molema", value: "207" },
    { name: "City of Matlosana", value: "208" },
    { name: "Ditsobotla", value: "209" },
    { name: "Greater Taung", value: "210" },
    { name: "Kagisano-Molopo", value: "211" },
    { name: "Kgetlengrivier", value: "212" },
    { name: "Lekwa-Teemane", value: "213" },
    { name: "Madibeng", value: "214" },
    { name: "Mahikeng", value: "215" },
    { name: "Mamusa", value: "216" },
    { name: "Maquassi Hills", value: "217" },
    { name: "Moretele", value: "218" },
    { name: "Moses Kotane", value: "219" },
    { name: "Naledi", value: "220" },
    { name: "Ramotshere Moiloa", value: "221" },
    { name: "Ratlou", value: "222" },
    { name: "Rustenburg", value: "223" },
    { name: "Tlokwe", value: "224" },
    { name: "Tswaing", value: "225" },
    { name: "Ventersdorp", value: "226" },
    { name: "Frances Baard", value: "227" },
    { name: "John Taolo Gaetsewe", value: "228" },
    { name: "Namakwa", value: "229" },
    { name: "Siyanda", value: "231" },
    { name: "Dikgatlong", value: "232" },
    { name: "Emthanjeni", value: "233" },
    { name: "Ga-Segonyana", value: "234" },
    { name: "Gamagara", value: "235" },
    { name: "Hantam", value: "236" },
    { name: "Joe Morolong", value: "237" },
    { name: "Kai !Garib", value: "238" },
    { name: "Kamiesberg", value: "239" },
    { name: "Kareeberg", value: "240" },
    { name: "Karoo Hoogland", value: "241" },
    { name: "Kgatelopele", value: "242" },
    { name: "Khái-Ma", value: "243" },
    { name: "//Khara Hais", value: "244" },
    { name: "!Kheis", value: "245" },
    { name: "Magareng", value: "246" },
    { name: "Mier", value: "247" },
    { name: "Nama Khoi", value: "248" },
    { name: "Phokwane", value: "249" },
    { name: "Renosterberg", value: "250" },
    { name: "Richtersveld", value: "251" },
    { name: "Siyancuma", value: "252" },
    { name: "Siyathemba", value: "253" },
    { name: "Sol Plaatje", value: "254" },
    { name: "Thembelihle", value: "255" },
    { name: "Tsantsabane", value: "256" },
    { name: "Ubuntu", value: "257" },
    { name: "Umsobomvu", value: "258" },
    { name: "Mangaung", value: "259" },
    { name: "Fezile Dabi", value: "260" },
    { name: "Lejweleputswa", value: "261" }
],

};
export const SouthAfricaRegions = [
  { name: "Gauteng", value: "01" },
  { name: "Eastern Cape", value: "02" },
  { name: "Limpopo", value: "03" },
  { name: "KwaZulu-Natal", value: "04" },
  { name: "Mpumalanga", value: "05" },
  { name: "Western Cape", value: "06" },
  { name: "North West", value: "07"},
  { name: "Northern Cape", value: "08" },
  { name: "Free State", value: "09" }
];

export const SouthAfricaMunicipalitiesByRegion = {
  // Gauteng (01)
  "01": [
    { name: "City of Johannesburg", value: "001" },
    { name: "City of Tshwane", value: "002" },
    { name: "Ekurhuleni", value: "003" },
    { name: "Sedibeng", value: "004" },
    { name: "West Rand", value: "005" },
    { name: "Emfuleni", value: "006" },
    { name: "Lesedi", value: "007" },
    { name: "Merafong City", value: "008" },
    { name: "Midvaal", value: "009" },
    { name: "Mogale City", value: "010" },
    { name: "Randfontein", value: "011" },
    { name: "Westonaria", value: "012" }
  ],
  // Eastern Cape (02)
  "02": [
    { name: "Buffalo City Metropolitan", value: "013" },
    { name: "Nelson Mandela Bay", value: "014" },
    { name: "Alfred Nzo District", value: "015" },
    { name: "Amathole District", value: "016" },
    { name: "Cacadu District", value: "018" },
    { name: "Chris Hani District", value: "019" },
    { name: "Joe Gqabi", value: "020" },
    { name: "OR Tambo District", value: "022" },
    { name: "Amahlathi", value: "023" },
    { name: "Baviaans", value: "024" },
    { name: "Blue Crane Route", value: "025" },
    { name: "Buffalo City", value: "026" },
    { name: "Camdeboo", value: "027" },
    { name: "Elundini", value: "028" },
    { name: "Emalahleni", value: "029" },
    { name: "Engcobo", value: "030" },
    { name: "Gariep", value: "031" },
    { name: "Great Kei", value: "032" },
    { name: "Ikwezi", value: "033" },
    { name: "Ingquza Hill", value: "034" },
    { name: "Inkwanca", value: "035" },
    { name: "Intsika Yethu", value: "036" },
    { name: "Inxuba Yethemba", value: "037" },
    { name: "King Sabata Dalindyebo", value: "038" },
    { name: "Kou-Kamma", value: "039" },
    { name: "Kouga", value: "040" },
    { name: "Lukhanji", value: "041" },
    { name: "Makana", value: "042" },
    { name: "Maletswai", value: "043" },
    { name: "Matatiele", value: "044" },
    { name: "Mbhashe", value: "045" },
    { name: "Mbizana", value: "046" },
    { name: "Mhlontlo", value: "047" },
    { name: "Mnquma Local", value: "048" },
    { name: "Ndlambe Local", value: "049" },
    { name: "Ngqushwa", value: "050" },
    { name: "Nkonkobe", value: "051" },
    { name: "Ntabankulu", value: "052" },
    { name: "Nxuba Local", value: "053" },
    { name: "Nyandeni", value: "054" },
    { name: "Port St Johns", value: "055" },
    { name: "Sakhisizwe", value: "056" },
    { name: "Senqu Local", value: "057" },
    { name: "Sundays River Valley", value: "058" },
    { name: "Tsolwana Local", value: "059" },
    { name: "Umzimvubu", value: "060" }
  ],
  // Limpopo (03)
  "03": [
    { name: "Capricorn", value: "061" },
    { name: "Mopani", value: "062" },
    { name: "Sekhukhune", value: "063" },
    { name: "Vhembe", value: "064" },
    { name: "Waterberg", value: "065" },
    { name: "Aganang", value: "066" },
    { name: "Ba-Phalaborwa", value: "067" },
    { name: "Bela-Bela", value: "068" },
    { name: "Blouberg", value: "069" },
    { name: "Elias Motsoaledi", value: "070" },
    { name: "Ephraim Mogale", value: "071" },
    { name: "Fetakgomo", value: "072" },
    { name: "Greater Giyani", value: "073" },
    { name: "Greater Letaba", value: "074" },
    { name: "Greater Tubatse", value: "075" },
    { name: "Greater Tzaneen", value: "076" },
    { name: "Lepelle-Nkumpi", value: "077" },
    { name: "Lephalale", value: "078" },
    { name: "Makhado", value: "079" },
    { name: "Makhuduthamaga", value: "080" },
    { name: "Maruleng", value: "081" },
    { name: "Modimolle", value: "082" },
    { name: "Mogalakwena", value: "083" },
    { name: "Molemole", value: "084" },
    { name: "Mookgophong", value: "085" },
    { name: "Musina", value: "086" },
    { name: "Mutale", value: "087" },
    { name: "Polokwane", value: "088" },
    { name: "Thabazimbi", value: "089" },
    { name: "Thulamela", value: "090" }
  ],
  // KwaZulu-Natal (04)
  "04": [
    { name: "eThekwini", value: "091" },
    { name: "Amajuba", value: "092" },
    { name: "iLembe", value: "094" },
    { name: "Sisonke", value: "095" },
    { name: "Ugu", value: "096" },
    { name: "uMgungundlovu", value: "097" },
    { name: "uMkhanyakude", value: "098" },
    { name: "uMzinyathi", value: "099" },
    { name: "uThukela", value: "100" },
    { name: "uThungulu", value: "101" },
    { name: "Zululand", value: "102" },
    { name: "Abaqulusi", value: "103" },
    { name: "Dannhauser", value: "104" },
    { name: "eDumbe", value: "105" },
    { name: "eMadlangeni", value: "106" },
    { name: "Emnambithi/Ladysmith", value: "107" },
    { name: "Endumeni Local", value: "108" },
    { name: "Ezingoleni", value: "109" },
    { name: "Greater Kokstad", value: "110" },
    { name: "Hibiscus Coast", value: "111" },
    { name: "Hlabisa", value: "112" },
    { name: "Imbabazane", value: "113" },
    { name: "Impendle", value: "114" },
    { name: "Indaka", value: "115" },
    { name: "Ingwe", value: "116" },
    { name: "Jozini", value: "117" },
    { name: "KwaDukuza", value: "118" },
    { name: "KwaSani", value: "119" },
    { name: "Mandeni", value: "120" },
    { name: "Maphumulo", value: "121" },
    { name: "Mbonambi", value: "122" },
    { name: "Mkhambathini", value: "123" },
    { name: "Mpofana", value: "124" },
    { name: "Msinga", value: "125" },
    { name: "Msunduzi", value: "126" },
    { name: "Mthonjaneni", value: "127" },
    { name: "Mtubatuba", value: "128" },
    { name: "Ndwedwe", value: "129" },
    { name: "Newcastle", value: "130" },
    { name: "Nkandla", value: "131" },
    { name: "Nongoma", value: "132" },
    { name: "Nquthu", value: "133" },
    { name: "Ntambanana", value: "134" },
    { name: "Okhahlamba", value: "135" },
    { name: "Richmond", value: "136" },
    { name: "The Big Five False Bay", value: "137" },
    { name: "Ubuhlebezwe", value: "138" },
    { name: "Ulundi", value: "139" },
    { name: "Umdoni", value: "140" },
    { name: "uMhlabuyalingana", value: "141" },
    { name: "uMhlathuze", value: "142" },
    { name: "uMlalazi", value: "143" },
    { name: "uMngeni", value: "144" },
    { name: "uMshwathi", value: "145" },
    { name: "Umtshezi", value: "146" },
    { name: "uMuziwabantu", value: "147" },
    { name: "Umvoti", value: "148" },
    { name: "Umzimkhulu", value: "149" },
    { name: "Umzumbe", value: "150" },
    { name: "uPhongolo", value: "151" },
    { name: "Vulamehlo", value: "152" }
  ],
  // Mpumalanga (05)
  "05": [
    { name: "Ehlanzeni", value: "153" },
    { name: "Gert Sibande", value: "154" },
    { name: "Nkangala", value: "155" },
    { name: "Albert Luthuli", value: "156" },
    { name: "Bushbuckridge", value: "157" },
    { name: "Dipaleseng", value: "158" },
    { name: "Dr JS Moroka", value: "159" },
    { name: "Emakhazeni", value: "160" },
    { name: "Emalahleni", value: "161" },
    { name: "Govan Mbeki", value: "162" },
    { name: "Lekwa", value: "163" },
    { name: "Mbombela", value: "164" },
    { name: "Mkhondo", value: "165" },
    { name: "Msukaligwa", value: "166" },
    { name: "Nkomazi", value: "167" },
    { name: "Pixley Ka Seme", value: "168" },
    { name: "Steve Tshwete", value: "169" },
    { name: "Thaba Chweu", value: "170" },
    { name: "Thembisile Hani", value: "171" },
    { name: "Umjindi", value: "172" },
    { name: "Victor Khanye", value: "173" }
  ],
  // Western Cape (06)
  "06": [
    { name: "City of Cape Town", value: "174" },
    { name: "Cape Winelands", value: "175" },
    { name: "Central Karoo", value: "176" },
    { name: "Eden", value: "177" },
    { name: "Overberg", value: "178" },
    { name: "West Coast", value: "179" },
    { name: "Beaufort West", value: "180" },
    { name: "Bergrivier", value: "181" },
    { name: "Bitou", value: "182" },
    { name: "Breede Valley", value: "183" },
    { name: "Cape Agulhas", value: "184" },
    { name: "Cederberg", value: "185" },
    { name: "Drakenstein", value: "186" },
    { name: "George", value: "187" },
    { name: "Hessequa", value: "188" },
    { name: "Kannaland", value: "189" },
    { name: "Knysna", value: "190" },
    { name: "Laingsburg", value: "191" },
    { name: "Langeberg", value: "192" },
    { name: "Matzikama", value: "193" },
    { name: "Mossel Bay", value: "194" },
    { name: "Oudtshoorn", value: "195" },
    { name: "Overstrand", value: "196" },
    { name: "Prince Albert", value: "197" },
    { name: "Saldanha Bay", value: "198" },
    { name: "Stellenbosch", value: "199" },
    { name: "Swartland", value: "200" },
    { name: "Swellendam", value: "201" },
    { name: "Theewaterskloof", value: "202" },
    { name: "Witzenberg", value: "203" }
  ],
  // North West (07)
  "07": [
    { name: "Bojanala Platinum", value: "204" },
    { name: "Dr Kenneth Kaunda", value: "205" },
    { name: "Dr Ruth Segomotsi Mompati", value: "206" },
    { name: "Ngaka Modiri Molema", value: "207" },
    { name: "City of Matlosana", value: "208" },
    { name: "Ditsobotla", value: "209" },
    { name: "Greater Taung", value: "210" },
    { name: "Kagisano-Molopo", value: "211" },
    { name: "Kgetlengrivier", value: "212" },
    { name: "Lekwa-Teemane", value: "213" },
    { name: "Madibeng", value: "214" },
    { name: "Mahikeng", value: "215" },
    { name: "Mamusa", value: "216" },
    { name: "Maquassi Hills", value: "217" },
    { name: "Moretele", value: "218" },
    { name: "Moses Kotane", value: "219" },
    { name: "Naledi", value: "220" },
    { name: "Ramotshere Moiloa", value: "221" },
    { name: "Ratlou", value: "222" },
    { name: "Rustenburg", value: "223" },
    { name: "Tlokwe", value: "224" },
    { name: "Tswaing", value: "225" },
    { name: "Ventersdorp", value: "226" }
  ],
  // Northern Cape (08)
  "08": [
    { name: "Frances Baard", value: "227" },
    { name: "John Taolo Gaetsewe", value: "228" },
    { name: "Namakwa", value: "229" },
    { name: "Pixley ka Seme", value: "230" },
    { name: "Siyanda", value: "231" },
    { name: "Dikgatlong", value: "232" },
    { name: "Emthanjeni", value: "233" },
    { name: "Ga-Segonyana", value: "234" },
    { name: "Gamagara", value: "235" },
    { name: "Hantam", value: "236" },
    { name: "Joe Morolong", value: "237" },
    { name: "Kai !Garib", value: "238" },
    { name: "Kamiesberg", value: "239" },
    { name: "Kareeberg", value: "240" },
    { name: "Karoo Hoogland", value: "241" },
    { name: "Kgatelopele", value: "242" },
    { name: "Khai-Ma", value: "243" },
    { name: "//Khara Hais", value: "244" },
    { name: "!Kheis", value: "245" },
    { name: "Magareng", value: "246" },
    { name: "Mier", value: "247" },
    { name: "Nama Khoi", value: "248" },
    { name: "Phokwane", value: "249" },
    { name: "Renosterberg", value: "250" },
    { name: "Richtersveld", value: "251" },
    { name: "Siyancuma", value: "252" },
    { name: "Siyathemba", value: "253" },
    { name: "Sol Plaatje", value: "254" },
    { name: "Thembelihle", value: "255" },
    { name: "Tsantsabane", value: "256" },
    { name: "Ubuntu", value: "257" },
    { name: "Umsobomvu", value: "258" }
  ],
  // Free State (09)
  "09": [
    { name: "Mangaung", value: "259" },
    { name: "Fezile Dabi", value: "260" },
    { name: "Lejweleputswa", value: "261" },
    { name: "Thabo Mofutsanyana", value: "263" },
    { name: "Xhariep", value: "264" },
    { name: "Dihlabeng", value: "265" },
    { name: "Kopanong", value: "266" },
    { name: "Letsemeng", value: "267" },
    { name: "Mafube", value: "268" },
    { name: "Maluti-a-Phofung", value: "269" },
    { name: "Mantsopa", value: "271" },
    { name: "Masilonyana", value: "272" },
    { name: "Matjhabeng", value: "273" },
    { name: "Metsimaholo", value: "274" },
    { name: "Mohokare", value: "275" },
    { name: "Moqhaka", value: "276" },
    { name: "Nala", value: "277" },
    { name: "Naledi", value: "278" },
    { name: "Ngwathe", value: "279" },
    { name: "Nketoana", value: "280" },
    { name: "Phumelela", value: "281" },
    { name: "Setsoto", value: "282" },
    { name: "Tokologo", value: "283" },
    { name: "Tswelopele", value: "284" }
  ]
};

// Flattened version for cases where we need all municipalities
export const SouthAfricaMunicipality = Object.values(SouthAfricaMunicipalitiesByRegion).flat();
export const kenyaRegions = [
  // Kenya regions (counties)
  { name: "Mombasa", value: 1 },
  { name: "Kwale", value: 2 },
  { name: "Kilifi", value: 3 },
  { name: "Tana River", value: 4 },
  { name: "Lamu", value: 5 },
  { name: "Taita Taveta", value: 6 },
  { name: "Garissa", value: 7 },
  { name: "Wajir", value: 8 },
  { name: "Mandera", value: 9 },
  { name: "Marsabit", value: 10 },
  { name: "Isiolo", value: 11 },
  { name: "Meru", value: 12 },
  { name: "Tharaka-Nithi", value: 13 },
  { name: "Embu", value: 14 },
  { name: "Kitui", value: 15 },
  { name: "Machakos", value: 16 },
  { name: "Makueni", value: 17 },
  { name: "Nyandarua", value: 18 },
  { name: "Nyeri", value: 19 },
  { name: "Kirinyaga", value: 20 },
  { name: "Murang'a", value: 21 },
  { name: "Kiambu", value: 22 },
  { name: "Turkana", value: 23 },
  { name: "West Pokot", value: 24 },
  { name: "Samburu", value: 25 },
  { name: "Trans Nzoia", value: 26 },
  { name: "Uasin Gishu", value: 27 },
  { name: "Elgeyo-Marakwet", value: 28 },
  { name: "Nandi", value: 29 },
  { name: "Baringo", value: 30 },
  { name: "Laikipia", value: 31 },
  { name: "Nakuru", value: 32 },
  { name: "Narok", value: 33 },
  { name: "Kajiado", value: 34 },
  { name: "Kericho", value: 35 },
  { name: "Bomet", value: 36 },
  { name: "Kakamega", value: 37 },
  { name: "Vihiga", value: 38 },
  { name: "Bungoma", value: 39 },
  { name: "Busia", value: 40 },
  { name: "Siaya", value: 41 },
  { name: "Kisumu", value: 42 },
  { name: "Homa Bay", value: 43 },
  { name: "Migori", value: 44 },
  { name: "Kisii", value: 45 },
  { name: "Nyamira", value: 46 },
  { name: "Nairobi City", value: 47 }
 ];
 
export const kenyaMunicipality = [
    // Kenya constituencies - Mombasa (1)
   // Kenya constituencies - Mombasa (1)
   { name: "Likoni", value: "001", regionCode: 1 },
   { name: "Nyali", value: "002", regionCode: 1 },
   { name: "Kisauni", value: "003", regionCode: 1 },
   { name: "Changamwe", value: "004", regionCode: 1 },
   { name: "Jomvu", value: "005", regionCode: 1 },
   { name: "Mvita", value: "006", regionCode: 1 },
   
   // Kwale (2)
   { name: "Matuga", value: "007", regionCode: 2 },
   { name: "Kinango", value: "008", regionCode: 2 },
   { name: "Lungalunga", value: "009", regionCode: 2 },
   { name: "Msambweni", value: "010", regionCode: 2 },
   
   // Kilifi (3)
   { name: "Ganze", value: "011", regionCode: 3 },
   { name: "Rabai", value: "012", regionCode: 3 },
   { name: "Malindi", value: "013", regionCode: 3 },
   { name: "Kaloleni", value: "014", regionCode: 3 },
   { name: "Magarini", value: "015", regionCode: 3 },
   { name: "Kilifi north", value: "016", regionCode: 3 },
   { name: "Kilifi south", value: "017", regionCode: 3 },
   
   // Tana River (4)
   { name: "Galole", value: "018", regionCode: 4 },
   { name: "Garsen", value: "019", regionCode: 4 },
   { name: "Bura", value: "020", regionCode: 4 },
   
   // Lamu (5)
   { name: "Lamu East", value: "021", regionCode: 5 },
   { name: "Lamu West", value: "022", regionCode: 5 },
   
   // Taita Taveta (6)
   { name: "Voi", value: "023", regionCode: 6 },
   { name: "Wundanyi", value: "024", regionCode: 6 },
   { name: "Taveta", value: "025", regionCode: 6 },
   { name: "Mwatate", value: "026", regionCode: 6 },
   
   // Garissa (7)
   { name: "Garissa township", value: "027", regionCode: 7 },
   { name: "Lagdera", value: "028", regionCode: 7 },
   { name: "Fafi", value: "029", regionCode: 7 },
   { name: "Dadaab", value: "030", regionCode: 7 },
   { name: "Ijara", value: "031", regionCode: 7 },
   { name: "Balambala", value: "032", regionCode: 7 },
   
   // Wajir (8)
   { name: "Wajir East", value: "033", regionCode: 8 },
   { name: "Wajir North", value: "034", regionCode: 8 },
   { name: "Wajir South", value: "035", regionCode: 8 },
   { name: "Wajir West", value: "036", regionCode: 8 },
   { name: "Eldas", value: "037", regionCode: 8 },
   { name: "Tarbaj", value: "038", regionCode: 8 },
   
   // Mandera (9)
   { name: "Mandera East", value: "039", regionCode: 9 },
   { name: "Lafey", value: "040", regionCode: 9 },
   { name: "Mandera West", value: "041", regionCode: 9 },
   { name: "Mandera Central", value: "042", regionCode: 9 },
   { name: "Mandera North", value: "043", regionCode: 9 },
   { name: "Banisa", value: "044", regionCode: 9 },
   
   // Marsabit (10)
   { name: "Saku", value: "045", regionCode: 10 },
   { name: "Laisamis", value: "046", regionCode: 10 },
   { name: "Moyale", value: "047", regionCode: 10 },
   { name: "North Horr", value: "048", regionCode: 10 },
   
   // Isiolo (11)
   { name: "Isiolo South", value: "049", regionCode: 11 },
   { name: "Isiolo North", value: "050", regionCode: 11 },
   
   // Meru (12)
   { name: "Imenti North", value: "051", regionCode: 12 },
   { name: "Buuri", value: "052", regionCode: 12 },
   { name: "Imenti central", value: "053", regionCode: 12 },
   { name: "Imenti south", value: "054", regionCode: 12 },
   { name: "Igembe north", value: "055", regionCode: 12 },
   { name: "Igembe central", value: "056", regionCode: 12 },
   { name: "Igembe South", value: "057", regionCode: 12 },
   { name: "Tigania east", value: "058", regionCode: 12 },
   { name: "Tigania West", value: "059", regionCode: 12 },
   
   // Tharaka-Nithi (13)
   { name: "Maara", value: "060", regionCode: 13 },
   { name: "Chuka", value: "061", regionCode: 13 },
   { name: "Tharaka", value: "062", regionCode: 13 },
   
   // Embu (14)
   { name: "Manyatta", value: "063", regionCode: 14 },
   { name: "Runyenjes", value: "064", regionCode: 14 },
   { name: "Mbeere North", value: "065", regionCode: 14 },
   { name: "Mbeere south", value: "066", regionCode: 14 },
   
   // Kitui (15)
   { name: "Kitui Central", value: "067", regionCode: 15 },
   { name: "Kitui West", value: "068", regionCode: 15 },
   { name: "Kitui east", value: "069", regionCode: 15 },
   { name: "Kitui south", value: "070", regionCode: 15 },
   { name: "Mwingi west", value: "071", regionCode: 15 },
   { name: "Mwingi east", value: "072", regionCode: 15 },
   { name: "Mwingi central", value: "073", regionCode: 15 },
   { name: "Mwingi north", value: "074", regionCode: 15 },
   { name: "Kitui rural", value: "075", regionCode: 15 },
   
   // Machakos (16)
   { name: "Machakos town", value: "076", regionCode: 16 },
   { name: "Mavoko", value: "077", regionCode: 16 },
   { name: "Kangundo", value: "078", regionCode: 16 },
   { name: "Matungulu", value: "079", regionCode: 16 },
   { name: "Kathiani", value: "080", regionCode: 16 },
   { name: "Mwala", value: "081", regionCode: 16 },
   { name: "Masinga", value: "082", regionCode: 16 },
   { name: "Yatta", value: "083", regionCode: 16 },
   
   // Makueni (17)
   { name: "Kibwezi east", value: "084", regionCode: 17 },
   { name: "Kibwezi west", value: "085", regionCode: 17 },
   { name: "Mbooni", value: "086", regionCode: 17 },
   { name: "Kaiti", value: "087", regionCode: 17 },
   { name: "Kilome", value: "088", regionCode: 17 },
   { name: "Makueni", value: "089", regionCode: 17 },
   
   // Nyandarua (18)
   { name: "Ol Kalou", value: "090", regionCode: 18 },
   { name: "Ol Joro Orok", value: "091", regionCode: 18 },
   { name: "Nyandarua south", value: "092", regionCode: 18 },
   { name: "Kinangop", value: "093", regionCode: 18 },
   { name: "Kipipiri", value: "094", regionCode: 18 },
   { name: "Ndaragwa", value: "095", regionCode: 18 },
   
   // Nyeri (19)
   { name: "Kieni", value: "096", regionCode: 19 },
   { name: "Nyeri town", value: "097", regionCode: 19 },
   { name: "Othaya", value: "098", regionCode: 19 },
   { name: "Mukurweini", value: "099", regionCode: 19 },
   { name: "Mathira", value: "100", regionCode: 19 },
   { name: "Tetu", value: "101", regionCode: 19 },
   
   // Kirinyaga (20)
   { name: "Ndia", value: "102", regionCode: 20 },
   { name: "Kirinyaga central", value: "103", regionCode: 20 },
   { name: "Mwea", value: "104", regionCode: 20 },
   { name: "Gichugu", value: "105", regionCode: 20 },
   
   // Murang'a (21)
   { name: "Kiharu", value: "106", regionCode: 21 },
   { name: "Kigumo", value: "107", regionCode: 21 },
   { name: "Kandara", value: "108", regionCode: 21 },
   { name: "Kangema", value: "109", regionCode: 21 },
   { name: "Mathioya", value: "110", regionCode: 21 },
   { name: "Gatanga", value: "111", regionCode: 21 },
   { name: "Maragwa", value: "112", regionCode: 21 },
   
   // Kiambu (22)
   { name: "Githunguri", value: "113", regionCode: 22 },
   { name: "Ruiru", value: "114", regionCode: 22 },
   { name: "Juja", value: "115", regionCode: 22 },
   { name: "Limuru", value: "116", regionCode: 22 },
   { name: "Lari", value: "117", regionCode: 22 },
   { name: "Kiambaa", value: "118", regionCode: 22 },
   { name: "Kiambu town", value: "119", regionCode: 22 },
   { name: "Kikuyu", value: "120", regionCode: 22 },
   { name: "Kabete", value: "121", regionCode: 22 },
   { name: "Gatundu South", value: "122", regionCode: 22 },
   { name: "Gatundu North", value: "123", regionCode: 22 },
   { name: "Thika town", value: "124", regionCode: 22 },
   
   // Turkana (23)
   { name: "Turkana central", value: "125", regionCode: 23 },
   { name: "Turkana west", value: "126", regionCode: 23 },
   { name: "Turkana south", value: "127", regionCode: 23 },
   { name: "Turkana east", value: "128", regionCode: 23 },
   { name: "Turkana north", value: "129", regionCode: 23 },
   { name: "Loima", value: "130", regionCode: 23 },
   
   // West Pokot (24)
   { name: "Sigor", value: "131", regionCode: 24 },
   { name: "Kacheliba", value: "132", regionCode: 24 },
   { name: "Pokot South", value: "133", regionCode: 24 },
   { name: "Kapenguria", value: "134", regionCode: 24 },
   
   // Samburu (25)
   { name: "Samburu west", value: "135", regionCode: 25 },
   { name: "Samburu East", value: "136", regionCode: 25 },
   { name: "Samburu North", value: "137", regionCode: 25 },
   
   // Trans Nzoia (26)
   { name: "Saboti", value: "138", regionCode: 26 },
   { name: "Kiminini", value: "139", regionCode: 26 },
   { name: "Kwanza", value: "140", regionCode: 26 },
   { name: "Endebess", value: "141", regionCode: 26 },
   { name: "Cherangani", value: "142", regionCode: 26 },
   
   // Uasin Gishu (27)
   { name: "Turbo", value: "143", regionCode: 27 },
   { name: "Soy", value: "144", regionCode: 27 },
   { name: "Ainabkoi", value: "145", regionCode: 27 },
   { name: "Moiben", value: "146", regionCode: 27 },
   { name: "Kesses", value: "147", regionCode: 27 },
   { name: "Kapseret", value: "148", regionCode: 27 },
   
   // Elgeyo-Marakwet (28)
   { name: "Keiyo North", value: "149", regionCode: 28 },
   { name: "Keiyo South", value: "150", regionCode: 28 },
   { name: "Marakwet East", value: "151", regionCode: 28 },
   { name: "Marakwet West", value: "152", regionCode: 28 },
   
   // Nandi (29)
   { name: "Chesumei", value: "153", regionCode: 29 },
   { name: "Emgwen", value: "154", regionCode: 29 },
   { name: "Tinderet", value: "155", regionCode: 29 },
   { name: "Nandi hills", value: "156", regionCode: 29 },
   { name: "Aldai", value: "157", regionCode: 29 },
   { name: "Mosop", value: "158", regionCode: 29 },
   
   // Baringo (30)
   { name: "Baringo south", value: "159", regionCode: 30 },
   { name: "Baringo central", value: "160", regionCode: 30 },
   { name: "Tiaty", value: "161", regionCode: 30 },
   { name: "Baringo north", value: "162", regionCode: 30 },
   { name: "Eldama Ravine", value: "163", regionCode: 30 },
   { name: "Mogotio", value: "164", regionCode: 30 },
   
   // Laikipia (31)
   { name: "Laikipia North", value: "165", regionCode: 31 },
   { name: "Laikipia West", value: "166", regionCode: 31 },
   { name: "Laikipia East", value: "167", regionCode: 31 },
   
   // Nakuru (32)
   { name: "Naivasha", value: "168", regionCode: 32 },
   { name: "Gilgil", value: "169", regionCode: 32 },
   { name: "Kuresoi south", value: "170", regionCode: 32 },
   { name: "Kuresoi North", value: "171", regionCode: 32 },
   { name: "Molo", value: "172", regionCode: 32 },
   { name: "Subukia", value: "173", regionCode: 32 },
   { name: "Bahati", value: "174", regionCode: 32 },
   { name: "Njoro", value: "175", regionCode: 32 },
   { name: "Nakuru East", value: "176", regionCode: 32 },
   { name: "Nakuru west", value: "177", regionCode: 32 },
   { name: "Rongai", value: "178", regionCode: 32 },
   
   // Narok (33)
   { name: "Narok North", value: "179", regionCode: 33 },
   { name: "Narok East", value: "180", regionCode: 33 },
   { name: "Narok south", value: "181", regionCode: 33 },
   { name: "Narok west", value: "182", regionCode: 33 },
   { name: "Kilgoris", value: "183", regionCode: 33 },
   { name: "Emurua Dikirr", value: "184", regionCode: 33 },
   
   // Kajiado (34)
   { name: "Kajiado Central", value: "185", regionCode: 34 },
   { name: "Kajiado east", value: "186", regionCode: 34 },
   { name: "Kajiado North", value: "187", regionCode: 34 },
   { name: "Kajiado west", value: "188", regionCode: 34 },
   { name: "Kajiado south", value: "189", regionCode: 34 },
   
   // Kericho (35)
   { name: "Ainamoi", value: "190", regionCode: 35 },
   { name: "Soin Sigowet", value: "191", regionCode: 35 },
   { name: "Kipkelion west", value: "192", regionCode: 35 },
   { name: "Belgut", value: "193", regionCode: 35 },
   { name: "Buret", value: "194", regionCode: 35 },
   { name: "Kipkelion", value: "195", regionCode: 35 },
   
   // Bomet (36)
   { name: "Bomet central", value: "196", regionCode: 36 },
   { name: "Bomet East", value: "197", regionCode: 36 },
   { name: "Konoin", value: "198", regionCode: 36 },
   { name: "Chepalungu", value: "199", regionCode: 36 },
   { name: "Sotik", value: "200", regionCode: 36 },
   
   // Kakamega (37)
   { name: "Khwisero", value: "201", regionCode: 37 },
   { name: "Kakamega south", value: "202", regionCode: 37 },
   { name: "Lurambi", value: "203", regionCode: 37 },
   { name: "Shinyalu", value: "204", regionCode: 37 },
   { name: "Butere", value: "205", regionCode: 37 },
   { name: "Mumias west", value: "206", regionCode: 37 },
   { name: "Mumias east", value: "207", regionCode: 37 },
   { name: "Malava", value: "208", regionCode: 37 },
   { name: "Lugari", value: "209", regionCode: 37 },
   { name: "Likuyani", value: "210", regionCode: 37 },
   { name: "Matungu", value: "211", regionCode: 37 },
   { name: "Navakholo", value: "212", regionCode: 37 },
   
   // Vihiga (38)
   { name: "Emuhaya", value: "213", regionCode: 38 },
   { name: "Luanda", value: "214", regionCode: 38 },
   { name: "Vihiga", value: "215", regionCode: 38 },
   { name: "Sabatia", value: "216", regionCode: 38 },
   { name: "Hamisi", value: "217", regionCode: 38 },
   
   // Bungoma (39)
   { name: "Kanduyi", value: "218", regionCode: 39 },
   { name: "Bumula", value: "219", regionCode: 39 },
   { name: "Kimilili", value: "220", regionCode: 39 },
   { name: "Sirisia", value: "221", regionCode: 39 },
   { name: "Tongaren", value: "222", regionCode: 39 },
   { name: "Kabuchai", value: "223", regionCode: 39 },
   { name: "Mt Elgon", value: "224", regionCode: 39 },
   { name: "Webuye east", value: "225", regionCode: 39 },
   { name: "Webuye west", value: "226", regionCode: 39 },
   
   // Busia (40)
   { name: "Busia town", value: "227", regionCode: 40 },
   { name: "Nambale", value: "228", regionCode: 40 },
   { name: "Budalangi", value: "229", regionCode: 40 },
   { name: "Funyula", value: "230", regionCode: 40 },
   { name: "Teso north", value: "231", regionCode: 40 },
   { name: "Teso south", value: "232", regionCode: 40 },
   { name: "Butula", value: "233", regionCode: 40 },
   
   // Siaya (41)
   { name: "Gem", value: "234", regionCode: 41 },
   { name: "Alego Usonga", value: "235", regionCode: 41 },
   { name: "Bondo", value: "236", regionCode: 41 },
   { name: "Rarieda", value: "237", regionCode: 41 },
   { name: "Ugenya", value: "238", regionCode: 41 },
   { name: "Ugunja", value: "239", regionCode: 41 },
   
   // Kisumu (42)
   { name: "Kisumu west", value: "240", regionCode: 42 },
   { name: "Seme", value: "241", regionCode: 42 },
   { name: "Kisumu east", value: "242", regionCode: 42 },
   { name: "Kisumu central", value: "243", regionCode: 42 },
   { name: "Nyando", value: "244", regionCode: 42 },
   { name: "Nyakach", value: "245", regionCode: 42 },
   { name: "Muhoroni", value: "246", regionCode: 42 },
   
   // Homa Bay (43)
   { name: "Homa bay town", value: "248", regionCode: 43 },
   { name: "Rangwe", value: "249", regionCode: 43 },
   { name: "Ndhiwa", value: "250", regionCode: 43 },
   { name: "Suba", value: "251", regionCode: 43 },
   { name: "Mbita", value: "252", regionCode: 43 },
   { name: "Kasipul kabondo", value: "253", regionCode: 43 },
   { name: "Kasipul", value: "254", regionCode: 43 },
   { name: "Rachuonyo", value: "255", regionCode: 43 },
   
   // Migori (44)
   { name: "Rongo", value: "256", regionCode: 44 },
   { name: "Uriri", value: "257", regionCode: 44 },
   { name: "Kuria West", value: "258", regionCode: 44 },
   { name: "Kuria East", value: "259", regionCode: 44 },
   { name: "Suna East", value: "260", regionCode: 44 },
   { name: "Suna West", value: "261", regionCode: 44 },
   { name: "Nyatike", value: "262", regionCode: 44 },
   { name: "Awendo", value: "263", regionCode: 44 },
   
   // Kisii (45)
   { name: "Kitutu chache south", value: "264", regionCode: 45 },
   { name: "Nyaribari chache", value: "265", regionCode: 45 },
   { name: "Kitutu chache north", value: "266", regionCode: 45 },
   { name: "Bobasi", value: "268", regionCode: 45 },
   { name: "Bomachoge borabu", value: "269", regionCode: 45 },
   { name: "Bomachoge chache", value: "270", regionCode: 45 },
   { name: "Bonchari", value: "271", regionCode: 45 },
   { name: "South mugirango", value: "272", regionCode: 45 },
   
   // Nyamira (46)
   { name: "West mugirango", value: "274", regionCode: 46 },
   { name: "North mugirango", value: "275", regionCode: 46 },
   { name: "Borabu", value: "276", regionCode: 46 },
   { name: "Kitutu Masaba", value: "277", regionCode: 46 },
   
   // Nairobi City (47)
   { name: "Westlands", value: "278", regionCode: 47 },
   { name: "Dagoretti North", value: "279", regionCode: 47 },
   { name: "Langata", value: "280", regionCode: 47 },
   { name: "Kibra", value: "281", regionCode: 47 },
   { name: "Dagoretti south", value: "283", regionCode: 47 },
   { name: "Starehe", value: "285", regionCode: 47 },
   { name: "Mathare", value: "286", regionCode: 47 },
   { name: "Roysambu", value: "287", regionCode: 47 },
   { name: "Ruaraka", value: "288", regionCode: 47 },
   { name: "Makadara", value: "289", regionCode: 47 },
   { name: "Embakasi central", value: "290", regionCode: 47 },
   { name: "Embakasi north", value: "291", regionCode: 47 },
   { name: "Embakasi east", value: "292", regionCode: 47 },
   { name: "Embakasi west", value: "293", regionCode: 47 },
   { name: "Embakasi south", value: "294", regionCode: 47 },
   { name: "Kamukunji", value: "295", regionCode: 47 },
   { name: "Kasarani", value: "296", regionCode: 47 }

 ];
 export const kenyaRegion = [
  // Kenya regions (counties)
  { name: "Mombasa", value: 1 },
  { name: "Kwale", value: 2 },
  { name: "Kilifi", value: 3 },
  { name: "Tana River", value: 4 },
  { name: "Lamu", value: 5 },
  { name: "Taita Taveta", value: 6 },
  { name: "Garissa", value: 7 },
  { name: "Wajir", value: 8 },
  { name: "Mandera", value: 9 },
  { name: "Marsabit", value: 10 },
];

 // Namibia-specific data
export const namibiaRegions = [
  { name: "Erongo", value: "08" },
  { name: "Hardap", value: "12" },
  { name: "Kavango East", value: "06" },
  { name: "Kavango West", value: "14" },
  { name: "Khomas", value: "11" },
  { name: "Kunene", value: "01" },
  { name: "Ohangwena", value: "04" },
  { name: "Omaheke", value: "10" },
  { name: "Omusati", value: "02" },
  { name: "Oshana", value: "03" },
  { name: "Oshikoto", value: "05" },
  { name: "Otjozondjupa", value: "09" },
  { name: "Zambezi ", value: "07" },
  { name: "Karas ", value: "013" },
 ];
 export const zambiaMunicipality = [
  // Western (1)
  { name: "Kalabo Central", value: "001", regionCode: 1 },
  { name: "Liuwa", value: "002", regionCode: 1 },
  { name: "Kaoma Central", value: "003", regionCode: 1 },
  { name: "Mangango", value: "004", regionCode: 1 },
  { name: "Luena", value: "005", regionCode: 1 },
  { name: "Luampa", value: "006", regionCode: 1 },
  { name: "Lukulu East", value: "007", regionCode: 1 },
  { name: "Mitete", value: "008", regionCode: 1 },
  { name: "Mongu Central", value: "009", regionCode: 1 },
  { name: "Nalikwanda", value: "010", regionCode: 1 },
  { name: "Mulobezi", value: "011", regionCode: 1 },
  { name: "Mwandi", value: "012", regionCode: 1 },
  { name: "Nalolo", value: "013", regionCode: 1 },
  { name: "Nkeyema", value: "014", regionCode: 1 },
  { name: "Senanga", value: "015", regionCode: 1 },
  { name: "Sesheke", value: "016", regionCode: 1 },
  { name: "Shang'ombo", value: "017", regionCode: 1 },
  { name: "Sioma", value: "018", regionCode: 1 },
  { name: "Sikongo", value: "019", regionCode: 1 },

  // Central (2)
  { name: "Bwacha", value: "020", regionCode: 2 },
  { name: "Chisamba", value: "021", regionCode: 2 },
  { name: "Chitambo", value: "022", regionCode: 2 },
  { name: "Itezhi-Tezhi", value: "023", regionCode: 2 },
  { name: "Kabwe Central", value: "024", regionCode: 2 },
  { name: "Kapiri Mposhi", value: "025", regionCode: 2 },
  { name: "Katuba", value: "026", regionCode: 2 },
  { name: "Keembe", value: "027", regionCode: 2 },
  { name: "Lufubu", value: "028", regionCode: 2 },
  { name: "Mkushi North", value: "029", regionCode: 2 },
  { name: "Mkushi South", value: "030", regionCode: 2 },
  { name: "Muchinga", value: "031", regionCode: 2 },
  { name: "Mumbwa", value: "032", regionCode: 2 },
  { name: "Mwembeshi", value: "033", regionCode: 2 },
  { name: "Nangoma", value: "034", regionCode: 2 },
  { name: "Serenje", value: "035", regionCode: 2 },

  // Eastern (3)
  { name: "Chadiza", value: "036", regionCode: 3 },
  { name: "Chasefu", value: "037", regionCode: 3 },
  { name: "Chipangali", value: "038", regionCode: 3 },
  { name: "Chipata Central", value: "039", regionCode: 3 },
  { name: "Kapoche", value: "040", regionCode: 3 },
  { name: "Kasenengwa", value: "041", regionCode: 3 },
  { name: "Kaumbwe", value: "042", regionCode: 3 },
  { name: "Luangeni", value: "043", regionCode: 3 },
  { name: "Lumezi", value: "044", regionCode: 3 },
  { name: "Lundazi", value: "045", regionCode: 3 },
  { name: "Malambo", value: "046", regionCode: 3 },
  { name: "Milanzi", value: "047", regionCode: 3 },
  { name: "Mkaika", value: "048", regionCode: 3 },
  { name: "Msanzala", value: "049", regionCode: 3 },
  { name: "Nyimba", value: "050", regionCode: 3 },
  { name: "Petauke Central", value: "051", regionCode: 3 },
  { name: "Sinda", value: "052", regionCode: 3 },
  { name: "Vubwi", value: "053", regionCode: 3 },

  // Luapula (4)
  { name: "Bahati", value: "054", regionCode: 4 },
  { name: "Bangweulu", value: "055", regionCode: 4 },
  { name: "Chembe", value: "056", regionCode: 4 },
  { name: "Chiengi", value: "057", regionCode: 4 },
  { name: "Chifunabuli", value: "058", regionCode: 4 },
  { name: "Chipili", value: "059", regionCode: 4 },
  { name: "Kawambwa", value: "060", regionCode: 4 },
  { name: "Luapula", value: "061", regionCode: 4 },
  { name: "Mambilima", value: "062", regionCode: 4 },
  { name: "Mansa Central", value: "063", regionCode: 4 },
  { name: "Milenge", value: "064", regionCode: 4 },
  { name: "Mwansabombwe", value: "065", regionCode: 4 },
  { name: "Mwense", value: "066", regionCode: 4 },
  { name: "Nchelenge", value: "067", regionCode: 4 },
  { name: "Pambashe", value: "068", regionCode: 4 },

  // Northern (5)
  { name: "Chilubi", value: "069", regionCode: 5 },
  { name: "Chimbamilonga", value: "070", regionCode: 5 },
  { name: "Kaputa", value: "071", regionCode: 5 },
  { name: "Kasama Central", value: "072", regionCode: 5 },
  { name: "Lubansenshi", value: "073", regionCode: 5 },
  { name: "Lukashya", value: "074", regionCode: 5 },
  { name: "Lunte", value: "075", regionCode: 5 },
  { name: "Lupososhi", value: "076", regionCode: 5 },
  { name: "Malole", value: "077", regionCode: 5 },
  { name: "Mbala", value: "078", regionCode: 5 },
  { name: "Mporokoso", value: "079", regionCode: 5 },
  { name: "Mpulungu", value: "080", regionCode: 5 },
  { name: "Senga Hill", value: "081", regionCode: 5 },

  // North-Western (6)
  { name: "Chavuma", value: "082", regionCode: 6 },
  { name: "Ikeleng'i", value: "083", regionCode: 6 },
  { name: "Kabompo", value: "084", regionCode: 6 },
  { name: "Kasempa", value: "085", regionCode: 6 },
  { name: "Manyinga", value: "086", regionCode: 6 },
  { name: "Mufumbwe", value: "087", regionCode: 6 },
  { name: "Mwililunga", value: "088", regionCode: 6 },
  { name: "Solwezi Central", value: "089", regionCode: 6 },
  { name: "Solwezi East", value: "090", regionCode: 6 },
  { name: "Solwezi West", value: "091", regionCode: 6 },
  { name: "Zambezi East", value: "092", regionCode: 6 },
  { name: "Zambezi West", value: "093", regionCode: 6 },

  // Southern (7)
  { name: "Bweengwa", value: "094", regionCode: 7 },
  { name: "Chikankata", value: "095", regionCode: 7 },
  { name: "Choma", value: "096", regionCode: 7 },
  { name: "Dundumwenzi", value: "097", regionCode: 7 },
  { name: "Gwembe", value: "098", regionCode: 7 },
  { name: "Kalomo Central", value: "099", regionCode: 7 },
  { name: "Katombola", value: "100", regionCode: 7 },
  { name: "Livingstone", value: "101", regionCode: 7 },
  { name: "Magoye", value: "102", regionCode: 7 },
  { name: "Mapatizya", value: "103", regionCode: 7 },
  { name: "Mazabuka Central", value: "104", regionCode: 7 },
  { name: "Mbabala", value: "105", regionCode: 7 },
  { name: "Monze Central", value: "106", regionCode: 7 },
  { name: "Moomba", value: "107", regionCode: 7 },
  { name: "Namwala", value: "108", regionCode: 7 },
  { name: "Pemba", value: "109", regionCode: 7 },
  { name: "Siavonga", value: "110", regionCode: 7 },
  { name: "Sinazongwe", value: "111", regionCode: 7 },

  // Copperbelt (8)
  { name: "Bwana Mkubwa", value: "112", regionCode: 8 },
  { name: "Chifubu", value: "113", regionCode: 8 },
  { name: "Chililabombwe", value: "114", regionCode: 8 },
  { name: "Chimwemwe", value: "115", regionCode: 8 },
  { name: "Chingola", value: "116", regionCode: 8 },
  { name: "Kabushi", value: "117", regionCode: 8 },
  { name: "Kafulafuta", value: "118", regionCode: 8 },
  { name: "Kalulushi", value: "119", regionCode: 8 },
  { name: "Kamfinsa", value: "120", regionCode: 8 },
  { name: "Kankoyo", value: "121", regionCode: 8 },
  { name: "Kantanshi", value: "122", regionCode: 8 },
  { name: "Kwacha", value: "123", regionCode: 8 },
  { name: "Luanshya", value: "124", regionCode: 8 },
  { name: "Lufwanyama", value: "125", regionCode: 8 },
  { name: "Masaiti", value: "126", regionCode: 8 },
  { name: "Mpongwe", value: "127", regionCode: 8 },
  { name: "Mufulira", value: "128", regionCode: 8 },
  { name: "Nchanga", value: "129", regionCode: 8 },
  { name: "Ndola Central", value: "130", regionCode: 8 },
  { name: "Nkana", value: "131", regionCode: 8 },
  { name: "Roan", value: "132", regionCode: 8 },
  { name: "Wusakile", value: "133", regionCode: 8 },

  // Lusaka (9)
  { name: "Chawama", value: "134", regionCode: 9 },
  { name: "Chilanga", value: "135", regionCode: 9 },
  { name: "Chirundu", value: "136", regionCode: 9 },
  { name: "Chongwe", value: "137", regionCode: 9 },
  { name: "Feira", value: "138", regionCode: 9 },
  { name: "Kabwata", value: "139", regionCode: 9 },
  { name: "Kafue", value: "140", regionCode: 9 },
  { name: "Kanyama", value: "141", regionCode: 9 },
  { name: "Lusaka Central", value: "142", regionCode: 9 },
  { name: "Mandevu", value: "143", regionCode: 9 },
  { name: "Matero", value: "144", regionCode: 9 },
  { name: "Munali", value: "145", regionCode: 9 },
  { name: "Rufunsa", value: "146", regionCode: 9 },

  // Muchinga (10)
  { name: "Chama North", value: "147", regionCode: 10 },
  { name: "Chama South", value: "148", regionCode: 10 },
  { name: "Chinsali", value: "149", regionCode: 10 },
  { name: "Isoka", value: "150", regionCode: 10 },
  { name: "Kanchibiya", value: "151", regionCode: 10 },
  { name: "Mafinga", value: "152", regionCode: 10 },
  { name: "Mfuwe", value: "153", regionCode: 10 },
  { name: "Mpika Central", value: "154", regionCode: 10 },
  { name: "Nakonde", value: "155", regionCode: 10 },
  { name: "Shiwa Ng'andu", value: "156", regionCode: 10 }
];

export const zambiaRegions = [
  { name: "Western", value: 1 },
  { name: "Central", value: 2 },
  { name: "Eastern", value: 3 },
  { name: "Luapula", value: 4 },
  { name: "Northern", value: 5 },
  { name: "North-Western", value: 6 },
  { name: "Southern", value: 7 },
  { name: "Copperbelt", value: 8 },
  { name: "Lusaka", value: 9 },
  { name: "Muchinga", value: 10 }
];

export const BurundiRegions = [
  { name: "Buhumuza", value: "01" },
  { name: "Bujumbura", value: "02" },
  { name: "Burunga", value: "03" },
  { name: "Butanyerera", value: "04" },
  { name: "Gitega", value: "05" }
];

export const BurundiMunicipality = [
  // Buhumuza (Code: 01)
  { name: "Butaganzwa", value: "001", region: "01" },
  { name: "Buthinda", value: "002", region: "01" },
  { name: "Cankuzo", value: "003", region: "01" },
  { name: "Gisagara", value: "004", region: "01" },
  { name: "Gisuru", value: "005", region: "01" },
  { name: "Muyinga", value: "006", region: "01" },
  { name: "Ruyigi", value: "007", region: "01" },

  // Bujumbura (Code: 02)
  { name: "Bubanza", value: "008", region: "02" },
  { name: "Cibitoke", value: "009", region: "02" },
  { name: "Mubimbi", value: "010", region: "02" },
  { name: "Muha", value: "011", region: "02" },
  { name: "Bukinanyana", value: "012", region: "02" },
  { name: "Mpanda", value: "013", region: "02" },
  { name: "Muhuta", value: "014", region: "02" },
  { name: "Mukaza", value: "015", region: "02" },
  { name: "Mugina", value: "016", region: "02" },
  { name: "Mugongo-Manga", value: "017", region: "02" },
  { name: "NahaNwanya", value: "018", region: "02" },

  // Burunga (Code: 03)
  { name: "Bururi", value: "019", region: "03" },
  { name: "Matana", value: "020", region: "03" },
  { name: "Makamba", value: "021", region: "03" },
  { name: "Mpinga-Kayove", value: "022", region: "03" },
  { name: "Mabanda", value: "023", region: "03" },
  { name: "Rumonge", value: "024", region: "03" },
  { name: "Rutana", value: "025", region: "03" },

  // Butanyerera (Code: 04)
  { name: "Busoni", value: "026", region: "04" },
  { name: "Matongo", value: "027", region: "04" },
  { name: "Kayanza", value: "028", region: "04" },
  { name: "Kiremba", value: "029", region: "04" },
  { name: "Kirundo", value: "030", region: "04" },
  { name: "Muhanga", value: "031", region: "04" },
  { name: "Muwumba", value: "032", region: "04" },
  { name: "Tangara", value: "033", region: "04" },

  // Gitega (Code: 05)
  { name: "Bigendana", value: "034", region: "05" },
  { name: "Karusi", value: "035", region: "05" },
  { name: "Kiganda", value: "036", region: "05" },
  { name: "Gishubi", value: "037", region: "05" },
  { name: "Muramvya", value: "038", region: "05" },
  { name: "Mvaro", value: "039", region: "05" },
  { name: "Nyabihanga", value: "040", region: "05" },
  { name: "Shombo", value: "041", region: "05" }
];
export const RwandaRegions = [
  { name: "City of Kigali", value: "01" },
  { name: "Eastern", value: "02" },
  { name: "Northern", value: "03" },
  { name: "Southern", value: "04" },
  { name: "Western", value: "05" }
];
export const RwandaMunicipality = [
  // City of Kigali (Code: 01)
  { name: "Gasabo", value: "001", region: "01" },
  { name: "Kicukiro", value: "002", region: "01" },
  { name: "Nyarugenge", value: "003", region: "01" },

  // Eastern (Code: 02)
  { name: "Bugesera", value: "004", region: "02" },
  { name: "Gatsibo", value: "005", region: "02" },
  { name: "Kayonza", value: "006", region: "02" },
  { name: "Kirche", value: "007", region: "02" },
  { name: "Ngoma", value: "008", region: "02" },
  { name: "Nyagatare", value: "009", region: "02" },
  { name: "Rwamagana", value: "010", region: "02" },

  // Northern (Code: 03)
  { name: "Burera", value: "011", region: "03" },
  { name: "Gakenke", value: "012", region: "03" },
  { name: "Gicumbi", value: "013", region: "03" },
  { name: "Musanze", value: "014", region: "03" },
  { name: "Rulindo", value: "015", region: "03" },

  // Southern (Code: 04)
  { name: "Gisagara", value: "016", region: "04" },
  { name: "Huye", value: "017", region: "04" },
  { name: "Kamonyi", value: "018", region: "04" },
  { name: "Muhanga", value: "019", region: "04" },
  { name: "Nyamagabe", value: "020", region: "04" },
  { name: "Nyanza", value: "021", region: "04" },
  { name: "Nyaruguru", value: "022", region: "04" },
  { name: "Ruhango", value: "023", region: "04" },

  // Western (Code: 05)
  { name: "Karongi", value: "024", region: "05" },
  { name: "Ngororero", value: "025", region: "05" },
  { name: "Nyabihu", value: "026", region: "05" },
  { name: "Nyamasheke", value: "027", region: "05" },
  { name: "Rubavu", value: "028", region: "05" },
  { name: "Rusizi", value: "029", region: "05" },
  { name: "Rutsiro", value: "030", region: "05" }
];

export const UgandaMunicipality = [
  // Northern
  { name: "Agago", value: "001" },
  { name: "Amolatar", value: "002" },
  { name: "Apac", value: "003" },
  { name: "Gulu", value: "004" },
  { name: "Kaberamaido", value: "005" },
  { name: "Kiryandongo", value: "006" },
  { name: "Kitgum", value: "007" },
  { name: "Lamwo", value: "008" },
  { name: "Lira", value: "009" },
  { name: "Nakapiripirit", value: "010" },
  { name: "Nwoya", value: "011" },
  { name: "Otuke", value: "012" },
  { name: "Pader", value: "013" },
  { name: "Pakwach", value: "014" },
  { name: "Yumbe", value: "015" },
  { name: "Zombo", value: "016" },

  // Eastern
  { name: "Bukedea", value: "017" },
  { name: "Budaka", value: "018" },
  { name: "Bududa", value: "019" },
  { name: "Bukwo", value: "020" },
  { name: "Buliisa", value: "021" },
  { name: "Buyende", value: "022" },
  { name: "Iganga", value: "023" },
  { name: "Jinja", value: "024" },
  { name: "Kaberamaido", value: "025" },
  { name: "Kaliro", value: "026" },
  { name: "Kampala", value: "027" },
  { name: "Kamuli", value: "028" },
  { name: "Kapelebyong", value: "029" },
  { name: "Kapchorwa", value: "030" },
  { name: "Kibuku", value: "031" },
  { name: "Kumi", value: "032" },
  { name: "Kween", value: "033" },
  { name: "Mbale", value: "034" },
  { name: "Manafwa", value: "035" },
  { name: "Mayuge", value: "036" },
  { name: "Mityana", value: "037" },
  { name: "Namutumba", value: "038" },
  { name: "Namayingo", value: "039" },
  { name: "Namisindwa", value: "040" },
  { name: "Namutumba", value: "041" },
  { name: "Pallisa", value: "042" },
  { name: "Serere", value: "043" },
  { name: "Sironko", value: "044" },
  { name: "Tororo", value: "045" },
  { name: "Wakiso", value: "046" },

  // Central
  { name: "Buvuma", value: "047" },
  { name: "Buikwe", value: "048" },
  { name: "Gomba", value: "049" },
  { name: "Kalangala", value: "050" },
  { name: "Kalungu", value: "051" },
  { name: "Kampala", value: "052" },
  { name: "Kayunga", value: "053" },
  { name: "Kiboga", value: "054" },
  { name: "Kyankwanzi", value: "055" },
  { name: "Luwero", value: "056" },
  { name: "Lyantonde", value: "057" },
  { name: "Mityana", value: "058" },
  { name: "Mubende", value: "059" },
  { name: "Mukono", value: "060" },
  { name: "Nakaseke", value: "061" },
  { name: "Nakasongola", value: "062" },
  { name: "Rakai", value: "063" },
  { name: "Sembabule", value: "064" },
  { name: "Wakiso", value: "065" },

  // Western
  { name: "Buliisa", value: "066" },
  { name: "Bushenyi", value: "067" },
  { name: "Hoima", value: "068" },
  { name: "Ibanda", value: "069" },
  { name: "Isingiro", value: "070" },
  { name: "Jinja", value: "071" },
  { name: "Kabale", value: "072" },
  { name: "Kabarole", value: "073" },
  { name: "Kagadi", value: "074" },
  { name: "Kakumiro", value: "075" },
  { name: "Kampala", value: "076" },
  { name: "Kasese", value: "077" },
  { name: "Kibaale", value: "078" },
  { name: "Kisoro", value: "079" },
  { name: "Kiryandongo", value: "080" },
  { name: "Kyenjojo", value: "081" },
  { name: "Kyegegwa", value: "082" },
  { name: "Kyenjojo", value: "083" },
  { name: "Kyegegwa", value: "084" },
  { name: "Mbarara", value: "085" },
  { name: "Mitooma", value: "086" },
  { name: "Mubende", value: "087" },
  { name: "Ntungamo", value: "088" },
  { name: "Ntoroko", value: "089" },
  { name: "Rubirizi", value: "090" },
  { name: "Rukungiri", value: "091" },
  { name: "Sheema", value: "092" },
  { name: "Sironko", value: "093" },
  { name: "Toronto", value: "094" },
  { name: "Wakiso", value: "095" },


];

export const UgandaRegions = [
  { name: "Northern", value: "01" },
  { name: "Eastern", value: "02" },
  { name: "Central", value: "03" },
  { name: "Western", value: "04" },
];


export const MalawiRegions = [
  { name: "Northern", value: "01" },
  { name: "Central", value: "02" },
  { name: "Southern", value: "03" },
];

export const MalawiMunicipality = [
  // Northern
  { name: "Chitipa", value: "001", region: "01" },
  { name: "Karonga", value: "002", region: "01" },
  { name: "Karonga Town", value: "003", region: "01" },
  { name: "Likoma", value: "004", region: "01" },
  { name: "Mzimba", value: "005", region: "01" },
  { name: "Nkhata Bay", value: "006", region: "01" },
  { name: "Rumphi", value: "007", region: "01" },

  // Central
  { name: "Dedza", value: "008", region: "02" },
  { name: "Dowa", value: "009", region: "02" },
  { name: "Kasungu", value: "010", region: "02" },
  { name: "Kasungu Municipality", value: "011", region: "02" },
  { name: "Lilongwe", value: "012", region: "02" },
  { name: "Lilongwe City", value: "013", region: "02" },
  { name: "Mchinji", value: "014", region: "02" },
  { name: "Nkhotakota", value: "015", region: "02" },
  { name: "Ntcheu", value: "016", region: "02" },
  { name: "Ntchisi", value: "017", region: "02" },
  { name: "Salima", value: "018", region: "02" },

  // Southern
  { name: "Balaka", value: "019", region: "03" },
  { name: "Blantyre", value: "020", region: "03" },
  { name: "Blantyre City", value: "021", region: "03" },
  { name: "Chikwawa", value: "022", region: "03" },
  { name: "Chiradzulu", value: "023", region: "03" },
  { name: "Machinga", value: "024", region: "03" },
  { name: "Mangochi", value: "025", region: "03" },
  { name: "Mangochi Town", value: "026", region: "03" },
  { name: "Mulanje", value: "027", region: "03" },
  { name: "Mwanza", value: "028", region: "03" },
  { name: "Neno", value: "029", region: "03" },
  { name: "Nsanje", value: "030", region: "03" },
  { name: "Phalombe", value: "031", region: "03" },
  { name: "Thyolo", value: "032", region: "03" },
  { name: "Zomba", value: "033", region: "03" },
  { name: "Zomba City", value: "034", region: "03" },
];


export const BurkinaFasoRegions = [
  { name: "Boucle du Mouhoun", value: "01" },
  { name: "Cascades", value: "02" },
  { name: "Centre", value: "03" },
  { name: "Centre-Est", value: "04" },
  { name: "Centre-Nord", value: "05" },
  { name: "Centre-Ouest", value: "06" },
  { name: "Centre-Sud", value: "07" },
  { name: "Est", value: "08" },
  { name: "Hauts-Bassins", value: "09" },
  { name: "Nord", value: "10" },
  { name: "Plateau-Central", value: "11" },
  { name: "Sahel", value: "12" },
  { name: "Sud-Ouest", value: "13" },
];

export const BurkinaFasoMunicipality = [
  // Boucle du Mouhoun
  { name: "Balé", value: "001" },
  { name: "Banwa", value: "002" },
  { name: "Kossi", value: "003" },
  { name: "Mouhoun", value: "004" },
  { name: "Nayala", value: "005" },
  { name: "Sourou", value: "006" },

  // Cascades
  { name: "Comoé", value: "007" },
  { name: "Léraba", value: "008" },

  // Centre
  { name: "Kadiogo", value: "009" },

  // Centre-Est
  { name: "Boulgou", value: "010" },
  { name: "Koulpélogo", value: "011" },
  { name: "Kouritenga", value: "012" },

  // Centre-Nord
  { name: "Bam", value: "013" },
  { name: "Namentenga", value: "014" },
  { name: "Sanmatenga", value: "015" },

  // Centre-Ouest
  { name: "Boulkiemdé", value: "016" },
  { name: "Sanguié", value: "017" },
  { name: "Sissili", value: "018" },
  { name: "Ziro", value: "019" },

  // Centre-Sud
  { name: "Bazèga", value: "020" },
  { name: "Nahouri", value: "021" },
  { name: "Zoundwéogo", value: "022" },

  // Est
  { name: "Gnagna", value: "023" },
  { name: "Gourma", value: "024" },
  { name: "Komondjari", value: "025" },
  { name: "Kompiènga", value: "026" },
  { name: "Tapoa", value: "027" },

  // Hauts-Bassins
  { name: "Houet Province", value: "028" },
  { name: "Kénédougou", value: "029" },
  { name: "Tuy", value: "030" },

  // Nord
  { name: "Loroum", value: "031" },
  { name: "Passoré", value: "032" },
  { name: "Yatenga", value: "033" },
  { name: "Zondoma", value: "034" },

  // Plateau-Central
  { name: "Ganzourgou", value: "035" },
  { name: "Kourwéogo", value: "036" },
  { name: "Oubritenga", value: "037" },

  // Sahel
  { name: "Oudalan", value: "038" },
  { name: "Passoré", value: "039" },
  { name: "Séno", value: "040" },
  { name: "Soum", value: "041" },
  { name: "Yagha", value: "042" },

  // Sud-Ouest
  { name: "Bougouriba", value: "043" },
  { name: "Ioba", value: "044" },
];
export const TanzaniaRegions = [
  { name: "Arusha", value: "01" },
  { name: "Dar es Salaam", value: "02" },
  { name: "Dodoma", value: "03" },
  { name: "Geita", value: "04" },
  { name: "Iringa", value: "05" },
  { name: "Kagera", value: "06" },
  { name: "Katavi", value: "07" },
  { name: "Kigoma", value: "08" },
  { name: "Kilimanjaro", value: "09" },
  { name: "Lindi", value: "10" },
  { name: "Manyara", value: "11" },
  { name: "Mara", value: "12" },
  { name: "Mbeya", value: "13" },
  { name: "Mjini Magharibi (Zanzibar Urban/West)", value: "14" },
  { name: "Morogoro", value: "15" },
  { name: "Mtwara", value: "16" },
  { name: "Mwanza", value: "17" },
  { name: "Njombe", value: "18" },
  { name: "Pemba North", value: "19" },
  { name: "Pemba South", value: "20" },
  { name: "Pwani (Coast)", value: "21" },
  { name: "Rukwa", value: "22" },
  { name: "Ruvuma", value: "23" },
  { name: "Shinyanga", value: "24" },
  { name: "Simiyu", value: "25" },
  { name: "Singida", value: "26" },
  { name: "Songwe", value: "27" },
  { name: "Tabora", value: "28" },
  { name: "Tanga", value: "29" }
];

export const TanzaniaMunicipalities = [
  // Arusha (01)
  { name: "Arusha Urban", value: "001", region: "01" },
  { name: "Arumeru East", value: "002", region: "01" },
  { name: "Arumeru West", value: "003", region: "01" },
  { name: "Babati Urban", value: "004", region: "01" },
  { name: "Babati Rural", value: "005", region: "01" },
  { name: "Karatu", value: "006", region: "01" },
  { name: "Karatu", value: "007", region: "01" },
  { name: "Longido", value: "008", region: "01" },
  { name: "Monduli", value: "009", region: "01" },
  { name: "Ngorongoro", value: "010", region: "01" },
  { name: "Simanjiro", value: "011", region: "01" },

  // Dar es Salaam (02)
  { name: "Ilala", value: "012", region: "02" },
  { name: "Kinondoni", value: "013", region: "02" },
  { name: "Temeke", value: "014", region: "02" },
  { name: "Ubungo", value: "015", region: "02" },
  { name: "Kigamboni", value: "016", region: "02" },
  { name: "Kinondoni Urban", value: "017", region: "02" },
  { name: "Mbagala", value: "018", region: "02" },
  { name: "Kibamba", value: "019", region: "02" },

  // Dodoma (03)
  { name: "Dodoma Urban", value: "020", region: "03" },
  { name: "Bahi", value: "021", region: "03" },
  { name: "Chamwino", value: "022", region: "03" },
  { name: "Chamwino", value: "023", region: "03" },
  { name: "Kongwa", value: "024", region: "03" },
  { name: "Mpwapwa", value: "025", region: "03" },
  { name: "Mpwapwa", value: "026", region: "03" },
  { name: "Singida North", value: "027", region: "03" },
  { name: "Singida Rural", value: "028", region: "03" },

  // Geita (04)
  { name: "Geita", value: "029", region: "04" },
  { name: "Bukombe", value: "030", region: "04" },
  { name: "Chato", value: "031", region: "04" },
  { name: "Nyang'hwale", value: "032", region: "04" },
  { name: "Mbogwe", value: "033", region: "04" },

  // Iringa (05)
  { name: "Iringa Urban", value: "034", region: "05" },
  { name: "Iringa Rural", value: "035", region: "05" },
  { name: "Kilolo", value: "036", region: "05" },
  { name: "Makete", value: "037", region: "05" },
  { name: "Mufindi North", value: "038", region: "05" },
  { name: "Mufindi South", value: "039", region: "05" },

  // Kagera (06)
  { name: "Bukoba Urban", value: "040", region: "06" },
  { name: "Bukoba Rural", value: "041", region: "06" },
  { name: "Biharamulo East", value: "042", region: "06" },
  { name: "Biharamulo West", value: "043", region: "06" },
  { name: "Chato", value: "044", region: "06" },
  { name: "Karagwe", value: "045", region: "06" },
  { name: "Kyerwa", value: "046", region: "06" },
  { name: "Missenyi", value: "047", region: "06" },
  { name: "Ngara", value: "048", region: "06" },

  // Katavi (07)
  { name: "Mlele", value: "049", region: "07" },
  { name: "Mpanda Urban", value: "050", region: "07" },
  { name: "Mpanda Rural", value: "051", region: "07" },

  // Kigoma (08)
  { name: "Kigoma Urban", value: "052", region: "08" },
  { name: "Kigoma Rural", value: "053", region: "08" },
  { name: "Buhigwe", value: "054", region: "08" },
  { name: "Kasulu Urban", value: "055", region: "08" },
  { name: "Kasulu Rural", value: "056", region: "08" },
  { name: "Kibondo", value: "057", region: "08" },
  { name: "Uvinza", value: "058", region: "08" },

  // Kilimanjaro (09)
  { name: "Hai", value: "059", region: "09" },
  { name: "Moshi Urban", value: "060", region: "09" },
  { name: "Moshi Rural", value: "061", region: "09" },
  { name: "Mwanga", value: "062", region: "09" },
  { name: "Rombo", value: "063", region: "09" },
  { name: "Same", value: "064", region: "09" },
  { name: "Siha", value: "065", region: "09" },

  // Lindi (10)
  { name: "Lindi Urban", value: "066", region: "10" },
  { name: "Lindi Rural", value: "067", region: "10" },
  { name: "Kilwa", value: "068", region: "10" },
  { name: "Nachingwea", value: "069", region: "10" },
  { name: "Ruangwa", value: "070", region: "10" },

  // Manyara (11)
  { name: "Babati Urban", value: "071", region: "11" },
  { name: "Babati Rural", value: "072", region: "11" },
  { name: "Hanang", value: "073", region: "11" },
  { name: "Kiteto", value: "074", region: "11" },
  { name: "Mbulu", value: "075", region: "11" },
  { name: "Simanjiro", value: "076", region: "11" },

  // Mara (12)
  { name: "Bunda", value: "077", region: "12" },
  { name: "Butiama", value: "078", region: "12" },
  { name: "Musoma Urban", value: "079", region: "12" },
  { name: "Musoma Rural", value: "080", region: "12" },
  { name: "Serengeti", value: "081", region: "12" },
  { name: "Tarime", value: "082", region: "12" },
  { name: "Rorya", value: "083", region: "12" },

  // Mbeya (13)
  { name: "Mbeya Urban", value: "084", region: "13" },
  { name: "Mbeya Rural", value: "085", region: "13" },
  { name: "Chunya", value: "086", region: "13" },
  { name: "Ileje", value: "087", region: "13" },
  { name: "Kyela", value: "088", region: "13" },
  { name: "Mbozi", value: "089", region: "13" },
  { name: "Rungwe", value: "090", region: "13" },

  // Mjini Magharibi (14)
  { name: "Magomeni", value: "091", region: "14" },
  { name: "Wete", value: "092", region: "14" },
  { name: "Chake-Chake", value: "093", region: "14" },

  // Morogoro (15)
  { name: "Morogoro Urban", value: "094", region: "15" },
  { name: "Morogoro Rural", value: "095", region: "15" },
  { name: "Kilosa", value: "096", region: "15" },
  { name: "Kilombero", value: "097", region: "15" },
  { name: "Mvomero", value: "098", region: "15" },
  { name: "Ulanga", value: "099", region: "15" },

  // Mtwara (16)
  { name: "Mtwara Urban", value: "100", region: "16" },
  { name: "Mtwara Rural", value: "101", region: "16" },
  { name: "Masasi", value: "102", region: "16" },
  { name: "Newala", value: "103", region: "16" },
  { name: "Tandahimba", value: "104", region: "16" },

  // Mwanza (17)
  { name: "Mwanza Urban", value: "105", region: "17" },
  { name: "Magu", value: "106", region: "17" },
  { name: "Misungwi", value: "107", region: "17" },
  { name: "Sengerema", value: "108", region: "17" },
  { name: "Kwimba", value: "109", region: "17" },
  { name: "Kwimba", value: "110", region: "17" },
  { name: "Geita", value: "111", region: "17" },
  { name: "Ukerewe", value: "112", region: "17" },

  // Njombe (18)
  { name: "Njombe Urban", value: "113", region: "18" },
  { name: "Njombe Rural", value: "114", region: "18" },
  { name: "Ludewa", value: "115", region: "18" },
  { name: "Makete", value: "116", region: "18" },
  { name: "Wanging'ombe", value: "117", region: "18" },

  // Pemba North (19)
  { name: "Wete", value: "118", region: "19" },
  { name: "Chake-Chake", value: "119", region: "19" },

  // Pemba South (20)
  { name: "Mkoani", value: "120", region: "20" },
  { name: "Chake-Chake", value: "121", region: "20" },

  // Pwani (Coast) (21)
  { name: "Bagamoyo", value: "122", region: "21" },
  { name: "Kibaha Urban", value: "123", region: "21" },
  { name: "Kibaha Urban", value: "124", region: "21" },
  { name: "Kibaha Rural", value: "125", region: "21" },
  { name: "Kisarawe", value: "126", region: "21" },
  { name: "Mafia", value: "127", region: "21" },
  { name: "Mkuranga", value: "128", region: "21" },
  { name: "Rufiji", value: "129", region: "21" },
  { name: "Kisarawe", value: "130", region: "21" },

  // Rukwa (22)
  { name: "Sumbawanga Urban", value: "131", region: "22" },
  { name: "Sumbawanga Rural", value: "132", region: "22" },
  { name: "Nkasi", value: "133", region: "22" },
  { name: "Mpanda", value: "134", region: "22" },

  // Ruvuma (23)
  { name: "Songea Urban", value: "135", region: "23" },
  { name: "Songea Rural", value: "136", region: "23" },
  { name: "Mbinga", value: "137", region: "23" },
  { name: "Tunduru North", value: "138", region: "23" },
  { name: "Tunduru South", value: "139", region: "23" },
  { name: "Namtumbo", value: "140", region: "23" },
  { name: "Peramiho", value: "141", region: "23" },

  // Shinyanga (24)
  { name: "Shinyanga Urban", value: "142", region: "24" },
  { name: "Shinyanga Urban", value: "143", region: "24" },
  { name: "Bariadi", value: "144", region: "24" },
  { name: "Bukombe", value: "145", region: "24" },
  { name: "Kahama", value: "146", region: "24" },
  { name: "Kishapu", value: "147", region: "24" },
  { name: "Maswa", value: "148", region: "24" },
  { name: "Meatu", value: "149", region: "24" },
  { name: "Msalala", value: "150", region: "24" },

  // Simiyu (25)
  { name: "Bariadi", value: "151", region: "25" },
  { name: "Busega", value: "152", region: "25" },
  { name: "Itilima", value: "153", region: "25" },
  { name: "Maswa", value: "154", region: "25" },
  { name: "Meatu", value: "155", region: "25" },

  // Singida (26)
  { name: "Singida Urban", value: "156", region: "26" },
  { name: "Singida Rural", value: "157", region: "26" },
  { name: "Iramba", value: "158", region: "26" },
  { name: "Manyoni", value: "159", region: "26" },
  { name: "Mkalama", value: "160", region: "26" },

  // Songwe (27)
  { name: "Songwe", value: "161", region: "27" },
  { name: "Mbozi", value: "162", region: "27" },
  { name: "Momba", value: "163", region: "27" },
  { name: "Ileje", value: "164", region: "27" },

  // Tabora (28)
  { name: "Tabora Urban", value: "165", region: "28" },
  { name: "Tabora Rural", value: "166", region: "28" },
  { name: "Igunga", value: "167", region: "28" },
  { name: "Nzega", value: "168", region: "28" },
  { name: "Sikonge", value: "169", region: "28" },
  { name: "Sikonge", value: "170", region: "28" },
  { name: "Urambo", value: "171", region: "28" },

  // Tanga (29)
  { name: "Tanga Urban", value: "172", region: "29" },
  { name: "Muheza", value: "173", region: "29" },
  { name: "Pangani", value: "174", region: "29" },
  { name: "Korogwe Urban", value: "175", region: "29" },
  { name: "Korogwe Rural", value: "176", region: "29" },
  { name: "Handeni Urban", value: "177", region: "29" },
  { name: "Handeni Rural", value: "178", region: "29" },
  { name: "Kilindi", value: "179", region: "29" },
  { name: "Lushoto", value: "180", region: "29" },
  { name: "Mkinga", value: "181", region: "29" },
  { name: "Bumbuli", value: "182", region: "29" }
];
export const AngolaRegions = [
  { name: "Bengo", value: "01" },
  { name: "Benguela", value: "02" },
  { name: "Bié", value: "03" },
  { name: "Cabinda", value: "04" },
  { name: "Cuando Cubango", value: "05" },
  { name: "Cuanza Norte", value: "07" },
  { name: "Cuanza Sul", value: "08" },
  { name: "Cunene", value: "09" },
  { name: "Huambo", value: "10" },
  { name: "Huíla", value: "11" },
  { name: "Luanda", value: "13" },
  { name: "Lunda Norte", value: "14" },
  { name: "Lunda Sul", value: "15" },
  { name: "Malanje", value: "16" },
  { name: "Moxico", value: "17" },
  { name: "Namibe", value: "19" },
  { name: "Uíge", value: "20" },
  { name: "Zaire", value: "21" }
];

export const AngolaMunicipalities = [
  // Bengo (01)
  { name: "Ambriz", value: "001", region: "01" },
  { name: "Bula Atumba", value: "002", region: "01" },
  { name: "Dande", value: "003", region: "01" },
  { name: "Dembos", value: "004", region: "01" },
  { name: "Nambuangongo", value: "005", region: "01" },
  { name: "Pango Aluquém", value: "006", region: "01" },
  { name: "Icolo e Bengo", value: "007", region: "01" },

  // Benguela (02)
  { name: "Benguela", value: "008", region: "02" },
  { name: "Baía Farta", value: "009", region: "02" },
  { name: "Balombo", value: "010", region: "02" },
  { name: "Chongoroi", value: "011", region: "02" },
  { name: "Cubal", value: "012", region: "02" },
  { name: "Ganda", value: "013", region: "02" },

  // Bié (03)
  { name: "Camacupa", value: "014", region: "03" },
  { name: "Catabola", value: "015", region: "03" },
  { name: "Chinguar", value: "016", region: "03" },
  { name: "Chitembo", value: "017", region: "03" },
  { name: "Cuemba", value: "018", region: "03" },
  { name: "Cuíto", value: "019", region: "03" },
  { name: "Nharea", value: "020", region: "03" },

  // Cabinda (04)
  { name: "Belize", value: "021", region: "04" },
  { name: "Buco Zau", value: "022", region: "04" },
  { name: "Cabinda (Municipality)", value: "023", region: "04" },

  // Cuando Cubango (05)
  { name: "Mavinga", value: "024", region: "05" },
  { name: "Rivungo", value: "025", region: "05" },
  { name: "Longa", value: "026", region: "05" },

  // Cuanza Norte (07)
  { name: "Ambaca", value: "030", region: "07" },
  { name: "Banga", value: "031", region: "07" },
  { name: "Bolongongo", value: "032", region: "07" },
  { name: "Cambambe", value: "033", region: "07" },
  { name: "Cazengo", value: "034", region: "07" },
  { name: "Golungo Alto", value: "035", region: "07" },
  { name: "Gonguembo", value: "036", region: "07" },
  { name: "Lucala", value: "037", region: "07" },
  { name: "Samba Caju", value: "038", region: "07" },
  { name: "Samba Leko", value: "039", region: "07" },

  // Cuanza Sul (08)
  { name: "Amboim", value: "040", region: "08" },
  { name: "Cassongue", value: "041", region: "08" },
  { name: "Conda", value: "042", region: "08" },
  { name: "Ebo", value: "043", region: "08" },
  { name: "Libolo", value: "044", region: "08" },
  { name: "Mussende", value: "045", region: "08" },
  { name: "Porto Amboim", value: "046", region: "08" },
  { name: "Quibala", value: "047", region: "08" },
  { name: "Seles", value: "048", region: "08" },

  // Cunene (09)
  { name: "Cahama", value: "049", region: "09" },
  { name: "Cuanhama", value: "050", region: "09" },
  { name: "Cuvelai", value: "051", region: "09" },
  { name: "Namacunde", value: "052", region: "09" },
  { name: "Ombadja", value: "053", region: "09" },

  // Huambo (10)
  { name: "Bailundo", value: "054", region: "10" },
  { name: "Caála", value: "055", region: "10" },
  { name: "Catchiungo", value: "056", region: "10" },
  { name: "Chipipa", value: "057", region: "10" },
  { name: "Huambo (Municipality)", value: "058", region: "10" },
  { name: "Londuimbali", value: "059", region: "10" },
  { name: "Mungo", value: "060", region: "10" },
  { name: "Tchicala Tcholohanga", value: "061", region: "10" },
  { name: "Ukuma", value: "062", region: "10" },

  // Huíla (11)
  { name: "Caconda", value: "063", region: "11" },
  { name: "Caluquembe", value: "064", region: "11" },
  { name: "Chicomba", value: "065", region: "11" },
  { name: "Chipindo", value: "066", region: "11" },
  { name: "Gambos", value: "067", region: "11" },
  { name: "Humpata", value: "068", region: "11" },
  { name: "Jamba", value: "069", region: "11" },
  { name: "Lubango (Municipality)", value: "070", region: "11" },
  { name: "Matala", value: "071", region: "11" },
  { name: "Quilengues", value: "072", region: "11" },
  { name: "Quipungo", value: "073", region: "11" },

  // Luanda (13)
  { name: "Belas", value: "078", region: "13" },
  { name: "Cazenga", value: "079", region: "13" },
  { name: "Cacuaco", value: "080", region: "13" },
  { name: "Kilamba Kiaxi", value: "081", region: "13" },
  { name: "Luanda (Municipality)", value: "082", region: "13" },

  // Lunda Norte (14)
  { name: "Chitato", value: "083", region: "14" },
  { name: "Cuango", value: "084", region: "14" },
  { name: "Cuilo", value: "085", region: "14" },
  { name: "Dundo (Municipality)", value: "086", region: "14" },
  { name: "Lucapa", value: "087", region: "14" },
  { name: "Xá-Muteba", value: "088", region: "14" },

  // Lunda Sul (15)
  { name: "Cacolo", value: "089", region: "15" },
  { name: "Dala", value: "090", region: "15" },
  { name: "Saurimo (Municipality)", value: "091", region: "15" },
  { name: "Muconda", value: "092", region: "15" },

  // Malanje (16)
  { name: "Cacuso", value: "093", region: "16" },
  { name: "Calandula", value: "094", region: "16" },
  { name: "Cambundi-Catembo", value: "095", region: "16" },
  { name: "Cangandala", value: "096", region: "16" },
  { name: "Kunda-dia-Base", value: "097", region: "16" },
  { name: "Luquembo", value: "098", region: "16" },
  { name: "Malanje (Municipality)", value: "099", region: "16" },
  { name: "Marimba", value: "100", region: "16" },
  { name: "Massango", value: "101", region: "16" },
  { name: "Mucari", value: "102", region: "16" },

  // Moxico (17)
  { name: "Alto Zambeze", value: "103", region: "17" },
  { name: "Bundas", value: "104", region: "17" },
  { name: "Cameia", value: "105", region: "17" },
  { name: "Camanongue", value: "106", region: "17" },
  { name: "Luena (Municipality)", value: "107", region: "17" },
  { name: "Luchazes", value: "108", region: "17" },
  { name: "Leua", value: "109", region: "17" },

  // Namibe (19)
  { name: "Bibala", value: "113", region: "19" },
  { name: "Camacuio", value: "114", region: "19" },
  { name: "Moçâmedes (Municipality)", value: "115", region: "19" },
  { name: "Tômbwa", value: "116", region: "19" },

  // Uíge (20)
  { name: "Alto Cauale", value: "117", region: "20" },
  { name: "Ambuila", value: "118", region: "20" },
  { name: "Bembe", value: "119", region: "20" },
  { name: "Buengas", value: "120", region: "20" },
  { name: "Damba", value: "121", region: "20" },
  { name: "Macocola", value: "122", region: "20" },
  { name: "Massango", value: "123", region: "20" },
  { name: "Puri", value: "124", region: "20" },
  { name: "Quimbele", value: "125", region: "20" },
  { name: "Sanza Pombo", value: "126", region: "20" },
  { name: "Songo", value: "127", region: "20" },
  { name: "Uíge (Municipality)", value: "128", region: "20" },
  { name: "Zombo", value: "129", region: "20" },

  // Zaire (21)
  { name: "Cuimba", value: "130", region: "21" },
  { name: "Mbanza Congo (Municipality)", value: "131", region: "21" },
  { name: "Nóqui", value: "132", region: "21" },
  { name: "Soyo", value: "133", region: "21" },
  { name: "Tomboco", value: "134", region: "21" }
];
export const EswatiniRegions = [
  { name: "Hhohho", value: "01" },
  { name: "Manzini", value: "02" },
  { name: "Lubombo", value: "03" },
  { name: "Shiselweni", value: "04" },
];

export const EswatiniMunicipality = [
  // Hhohho
  { name: "Uhleni", value: "001", region: "01" },
  { name: "Bulandzeni", value: "002", region: "01" },
  { name: "Hhukwini", value: "003", region: "01" },
  { name: "Lobamba", value: "004", region: "01" },
  { name: "Lobamba Lomdzala", value: "005", region: "01" },
  { name: "Mafutseni", value: "006", region: "01" },
  { name: "Maphalaleni", value: "007", region: "01" },
  { name: "Mbabane East", value: "008", region: "01" },
  { name: "Mbabane West", value: "009", region: "01" },
  { name: "Mhlangatane", value: "010", region: "01" },
  { name: "Motjane", value: "011", region: "01" },
  { name: "Nkhaba", value: "012", region: "01" },
  { name: "Ntfonjeni", value: "013", region: "01" },
  { name: "Pigg's Peak", value: "014", region: "01" },
  { name: "Timphisini", value: "015", region: "01" },

  // Manzini
  { name: "Kukhanyeni", value: "016", region: "02" },
  { name: "Hlambanyatsi", value: "017", region: "02" },
  { name: "Kwaluseni", value: "018", region: "02" },
  { name: "Lamgabhi", value: "019", region: "02" },
  { name: "Lobamba", value: "020", region: "02" },
  { name: "Mafutseni", value: "021", region: "02" },
  { name: "Manzini North", value: "022", region: "02" },
  { name: "Manzini South", value: "023", region: "02" },
  { name: "Mkhiweni", value: "024", region: "02" },
  { name: "Mtfongwaneni", value: "025", region: "02" },
  { name: "Ngwempisi", value: "026", region: "02" },
  { name: "Nhlambeni", value: "027", region: "02" },
  { name: "Ntondozi", value: "028", region: "02" },
  { name: "Phondo", value: "029", region: "02" },
  { name: "Sigwe", value: "030", region: "02" },
  { name: "Zombodze Emuva", value: "031", region: "02" },

  // Lubombo
  { name: "Dvokodvweni", value: "032", region: "03" },
  { name: "Hlane", value: "033", region: "03" },
  { name: "Lugongolweni", value: "034", region: "03" },
  { name: "Lomahasha", value: "035", region: "03" },
  { name: "Lubuli", value: "036", region: "03" },
  { name: "Matsanjeni North", value: "037", region: "03" },
  { name: "Matsanjeni South", value: "038", region: "03" },
  { name: "Mhlume", value: "039", region: "03" },
  { name: "Mpholonjeni", value: "040", region: "03" },
  { name: "Siphofaneni", value: "041", region: "03" },
  { name: "Siteki", value: "042", region: "03" },

  // Shiselweni
  { name: "Gege", value: "043", region: "04" },
  { name: "Hosea", value: "044", region: "04" },
  { name: "Kubuta", value: "045", region: "04" },
  { name: "Maseyisini", value: "046", region: "04" },
  { name: "Matsanjeni South", value: "047", region: "04" },
  { name: "Mtsambama", value: "048", region: "04" },
  { name: "Ngudzeni", value: "049", region: "04" },
  { name: "Nkwene", value: "050", region: "04" },
  { name: "Sandleni", value: "051", region: "04" },
  { name: "Shiselweni I", value: "052", region: "04" },
  { name: "Shiselweni II", value: "053", region: "04" },
  { name: "Sigwe", value: "054", region: "04" },
  { name: "Somntongo", value: "055", region: "04" },
  { name: "Zombodze", value: "056", region: "04" },
];
export const LesothoRegions = [
  { name: "Berea", value: "01" },
  { name: "Butha-Buthe", value: "02" },
  { name: "Leribe", value: "03" },
  { name: "Mafeteng", value: "04" },
  { name: "Maseru", value: "05" },
  { name: "Mohale's Hoek", value: "06" },
  { name: "Mokhotlong", value: "07" },
  { name: "Qacha's Nek", value: "08" },
  { name: "Quthing", value: "09" },
  { name: "Thaba-Tseka", value: "10" }
];

export const LesothoMunicipalities = [
  // Berea (01)
  { name: "Bela-Bela", value: "001", region: "01" },
  { name: "Khafung", value: "002", region: "01" },
  { name: "Khubetsoana", value: "003", region: "01" },
  { name: "Mabote", value: "004", region: "01" },
  { name: "Makhoroana", value: "005", region: "01" },
  { name: "Malimong", value: "006", region: "01" },
  { name: "Mosalemane", value: "007", region: "01" },
  { name: "Teyateyaneng", value: "008", region: "01" },
  { name: "Thuathe", value: "009", region: "01" },
  { name: "Tšoana-Makhulo", value: "010", region: "01" },
  { name: "Kolonyama", value: "011", region: "01" },
  { name: "Mapoteng", value: "012", region: "01" },
  { name: "Seponono", value: "013", region: "01" },

  // Butha-Buthe (02)
  { name: "Butha-Buthe", value: "014", region: "02" },
  { name: "Hololo", value: "015", region: "02" },
  { name: "Mechachane", value: "016", region: "02" },
  { name: "Motete", value: "017", region: "02" },
  { name: "Qalo", value: "018", region: "02" },

  // Leribe (03)
  { name: "Hlotse", value: "019", region: "03" },
  { name: "Kolonyama", value: "020", region: "03" },
  { name: "Leribe", value: "021", region: "03" },
  { name: "Mahobong", value: "022", region: "03" },
  { name: "Maliba-Matšo", value: "023", region: "03" },
  { name: "Maputsoe", value: "024", region: "03" },
  { name: "Matlakeng", value: "025", region: "03" },
  { name: "Moselinyane", value: "026", region: "03" },
  { name: "Mphosong", value: "027", region: "03" },
  { name: "Peka", value: "028", region: "03" },
  { name: "Pela-Tšoeu", value: "029", region: "03" },
  { name: "Thaba-Phatšoa", value: "030", region: "03" },
  { name: "Tsikoane", value: "031", region: "03" },

  // Mafeteng (04)
  { name: "Mafeteng", value: "032", region: "04" },
  { name: "Thaba-Phechela", value: "033", region: "04" },
  { name: "Matelile", value: "034", region: "04" },
  { name: "Qalabane", value: "035", region: "04" },
  { name: "Maliepetsane", value: "036", region: "04" },
  { name: "Thabana-Morena", value: "037", region: "04" },
  { name: "Kolo", value: "038", region: "04" },
  { name: "Tsakholo", value: "039", region: "04" },
  { name: "Phokalla", value: "040", region: "04" },

  // Maseru (05)
  { name: "Abia", value: "041", region: "05" },
  { name: "Koro-Koro", value: "042", region: "05" },
  { name: "Likotsi", value: "043", region: "05" },
  { name: "Lithabaneng", value: "044", region: "05" },
  { name: "Lithoteng", value: "045", region: "05" },
  { name: "Maama", value: "046", region: "05" },
  { name: "Machache", value: "047", region: "05" },
  { name: "Majoe-a-Litšoene", value: "048", region: "05" },
  { name: "Makhaleng", value: "049", region: "05" },
  { name: "Maletsunyane", value: "050", region: "05" },
  { name: "Maseru Central", value: "051", region: "05" },
  { name: "Matala", value: "052", region: "05" },
  { name: "Matsieng", value: "053", region: "05" },
  { name: "Motimposo", value: "054", region: "05" },
  { name: "Qeme", value: "055", region: "05" },
  { name: "Qoaling", value: "056", region: "05" },
  { name: "Rothe", value: "057", region: "05" },
  { name: "Thetsane", value: "058", region: "05" },

  // Mohale's Hoek (06)
  { name: "Hloahloeng", value: "059", region: "06" },
  { name: "Mekaling", value: "060", region: "06" },
  { name: "Mohale's Hoek", value: "061", region: "06" },
  { name: "Mpharane", value: "062", region: "06" },
  { name: "Phamong", value: "063", region: "06" },
  { name: "Taung", value: "064", region: "06" },
  { name: "Tsoelike", value: "065", region: "06" },
  { name: "Qhoaling", value: "066", region: "06" },

  // Mokhotlong (07)
  { name: "Bobatsi", value: "067", region: "07" },
  { name: "Malingoaneng", value: "068", region: "07" },
  { name: "Mokhotlong", value: "069", region: "07" },
  { name: "Senqu", value: "070", region: "07" },

  // Qacha's Nek (08)
  { name: "Lebakeng", value: "071", region: "08" },
  { name: "Qacha's Nek", value: "072", region: "08" },
  { name: "Tsoelike", value: "073", region: "08" },

  // Quthing (09)
  { name: "Moyeni", value: "074", region: "09" },
  { name: "Qhoali", value: "075", region: "09" },
  { name: "Mount Moorosi", value: "076", region: "09" },
  { name: "Sebapala", value: "077", region: "09" },
  { name: "Tele", value: "078", region: "09" },

  // Thaba-Tseka (10)
  { name: "Mantšonyane", value: "079", region: "10" },
  { name: "Mashai", value: "080", region: "10" },
  { name: "Semena", value: "081", region: "10" },
  { name: "Thaba-Tseka", value: "082", region: "10" },
  { name: "Sehonghong", value: "083", region: "10" },
  { name: "Seshote", value: "084", region: "10" },
  { name: "Lesobeng", value: "085", region: "10" }
];
export const CameroonRegions = [
  { name: "Adamawa", value: "01" },
  { name: "Centre", value: "02" },
  { name: "East", value: "03" },
  { name: "Far North", value: "04" },
  { name: "Littoral", value: "05" },
  { name: "North", value: "06" },
  { name: "North-West", value: "07" },
  { name: "West", value: "08" },
  { name: "South", value: "09" },
  { name: "South-West", value: "10" }
];
export const CameroonMunicipality = [
  // Adamawa
  { name: "Djérem", value: "001" },
  { name: "Faro-et-Déo", value: "002" },
  { name: "Mayo-Banyo", value: "003" },
  { name: "Mbéré", value: "004" },
  { name: "Vina", value: "005" },

  // Centre
  { name: "Haute-Sanaga", value: "006" },
  { name: "Lekié", value: "007" },
  { name: "Mbam-et-Inoubou", value: "008" },
  { name: "Mbam-et-Kim", value: "009" },
  { name: "Méfou-et-Afamba", value: "010" },
  { name: "Méfou-et-Akono", value: "011" },
  { name: "Mfoundi (includes Yaoundé)", value: "012" },
  { name: "Nyong-et-Kéllé", value: "013" },
  { name: "Nyong-et-Mfoumou", value: "014" },
  { name: "Nyong-et-So'o", value: "015" },

  // East
  { name: "Boumba-et-Ngoko", value: "016" },
  { name: "Haut-Nyong", value: "017" },
  { name: "Kadey", value: "018" },
  { name: "Lom-et-Djérem", value: "019" },

  // Far North
  { name: "Diamaré", value: "020" },
  { name: "Logone-et-Chari", value: "021" },
  { name: "Mayo-Danay", value: "022" },
  { name: "Mayo-Kani", value: "023" },
  { name: "Mayo-Sava", value: "024" },
  { name: "Mayo-Tsanaga", value: "025" },

  // Littoral
  { name: "Moungo", value: "026" },
  { name: "Nkam", value: "027" },
  { name: "Sanaga-Maritime", value: "028" },
  { name: "Wouri (includes Douala)", value: "029" },

  // North
  { name: "Bénoué", value: "030" },
  { name: "Faro", value: "031" },
  { name: "Mayo-Louti", value: "032" },
  { name: "Mayo-Rey", value: "033" },

  // North-West
  { name: "Boyo", value: "034" },
  { name: "Bui", value: "035" },
  { name: "Donga-Mantung", value: "036" },
  { name: "Menchum", value: "037" },
  { name: "Mezam", value: "038" },
  { name: "Momo", value: "039" },
  { name: "Ngo-Ketunjia", value: "040" },

  // West
  { name: "Bamboutos", value: "041" },
  { name: "Haut-Nkam", value: "042" },
  { name: "Hauts-Plateaux", value: "043" },
  { name: "Koung-Khi", value: "044" },
  { name: "Ménoua", value: "045" },
  { name: "Mifi", value: "046" },
  { name: "Ndé", value: "047" },
  { name: "Noun", value: "048" },

  // South
  { name: "Dja-et-Lobo", value: "049" },
  { name: "Mvila", value: "050" },
  { name: "Océan", value: "051" },
  { name: "Vallée-du-Ntem", value: "052" },

  // South-West
  { name: "Fako", value: "053" },
  { name: "Kupe-Muanenguba", value: "054" },
  { name: "Lebialem", value: "055" },
  { name: "Manyu", value: "056" },
  { name: "Meme", value: "057" },
  { name: "Ndian", value: "058" }
];
export const drcMunicipality = [
  // Bas-Uélé (BU) - 01
  { name: "Aketi", value: "001", regionCode: 1 },
  { name: "Ango", value: "002", regionCode: 1 },
  { name: "Aru", value: "003", regionCode: 1 },
  { name: "Bambesa", value: "004", regionCode: 1 },
  { name: "Bondo", value: "005", regionCode: 1 },
  { name: "Buta", value: "006", regionCode: 1 },
  { name: "Poko", value: "007", regionCode: 1 },

  // Équateur (EQ) - 02
  { name: "Basankusu", value: "008", regionCode: 2 },
  { name: "Bikoro", value: "009", regionCode: 2 },
  { name: "Bolomba", value: "010", regionCode: 2 },
  { name: "Bomongo", value: "011", regionCode: 2 },
  { name: "Ingende", value: "012", regionCode: 2 },
  { name: "Lukolela", value: "013", regionCode: 2 },
  { name: "Makanza", value: "014", regionCode: 2 },
  { name: "Mongala", value: "015", regionCode: 2 },
  { name: "Bongandanga", value: "016", regionCode: 2 },
  { name: "Befale", value: "017", regionCode: 2 },
  { name: "Boende", value: "018", regionCode: 2 },
  { name: "Bokungu", value: "019", regionCode: 2 },
  { name: "Basoko", value: "020", regionCode: 2 },
  { name: "Bafwasende", value: "021", regionCode: 2 },
  { name: "Banalia", value: "022", regionCode: 2 },

  // Haut-Katanga (HK) - 03
  { name: "Lubumbashi", value: "023", regionCode: 3 },
  { name: "Likasi", value: "024", regionCode: 3 },
  { name: "Kambove", value: "025", regionCode: 3 },
  { name: "Kasenga", value: "026", regionCode: 3 },
  { name: "Kipushi", value: "027", regionCode: 3 },
  { name: "Mitwaba", value: "028", regionCode: 3 },
  { name: "Pweto", value: "029", regionCode: 3 },
  { name: "Sakania", value: "030", regionCode: 3 },

  // Haut-Lomami (HL) - 04
  { name: "Kamina", value: "031", regionCode: 4 },
  { name: "Bukama", value: "032", regionCode: 4 },
  { name: "Kabongo", value: "033", regionCode: 4 },
  { name: "Kaniama", value: "034", regionCode: 4 },
  { name: "Malemba-Nkulu", value: "035", regionCode: 4 },

  // Haut-Uélé (HU) - 05
  { name: "Isiro", value: "036", regionCode: 5 },
  { name: "Dungu", value: "037", regionCode: 5 },
  { name: "Faradje", value: "038", regionCode: 5 },
  { name: "Niangara", value: "039", regionCode: 5 },
  { name: "Rungu", value: "040", regionCode: 5 },
  { name: "Wamba", value: "041", regionCode: 5 },
  { name: "Watsa", value: "042", regionCode: 5 },

  // Ituri (IT) - 06
  { name: "Bunia", value: "043", regionCode: 6 },
  { name: "Aru", value: "044", regionCode: 6 },
  { name: "Djugu", value: "045", regionCode: 6 },
  { name: "Irumu", value: "046", regionCode: 6 },
  { name: "Mahagi", value: "047", regionCode: 6 },
  { name: "Mambasa", value: "048", regionCode: 6 },

  // Kasaï (KS) - 07
  { name: "Luebo", value: "049", regionCode: 7 },
  { name: "Mweka", value: "050", regionCode: 7 },
  { name: "Kamonia", value: "051", regionCode: 7 },
  { name: "Tshikapa", value: "052", regionCode: 7 },

  // Kasaï-Central (KC) - 08
  { name: "Demba", value: "053", regionCode: 8 },
  { name: "Dibaya", value: "054", regionCode: 8 },
  { name: "Kazumba", value: "055", regionCode: 8 },
  { name: "Lulua", value: "056", regionCode: 8 },
  { name: "Kananga", value: "057", regionCode: 8 },

  // Kasaï-Oriental (KE) - 09
  { name: "Mbuji-Mayi", value: "058", regionCode: 9 },
  { name: "Kabeya-Kamwanga", value: "059", regionCode: 9 },
  { name: "Katanda", value: "060", regionCode: 9 },
  { name: "Tshilenge", value: "061", regionCode: 9 },

  // Kinshasa (KN) - 10
  { name: "Barumbu", value: "062", regionCode: 10 },
  { name: "Gombe", value: "063", regionCode: 10 },
  { name: "Kinshasa", value: "064", regionCode: 10 },
  { name: "Kintambo", value: "065", regionCode: 10 },
  { name: "Lingwala", value: "066", regionCode: 10 },
  { name: "Bandalungwa", value: "067", regionCode: 10 },
  { name: "Kasa-Vubu", value: "068", regionCode: 10 },
  { name: "Kalamu", value: "069", regionCode: 10 },
  { name: "Ngiri-Ngiri", value: "070", regionCode: 10 },
  { name: "Selembao", value: "071", regionCode: 10 },
  { name: "Bumbu", value: "072", regionCode: 10 },
  { name: "Makala", value: "073", regionCode: 10 },
  { name: "Ngaba", value: "074", regionCode: 10 },
  { name: "Lemba", value: "075", regionCode: 10 },
  { name: "Matete", value: "076", regionCode: 10 },
  { name: "Kisenso", value: "077", regionCode: 10 },
  { name: "Limete", value: "078", regionCode: 10 },
  { name: "Masina", value: "079", regionCode: 10 },
  { name: "Kimbanseke", value: "080", regionCode: 10 },
  { name: "Nsele", value: "081", regionCode: 10 },
  { name: "Maluku", value: "082", regionCode: 10 },
  { name: "Ndjili", value: "083", regionCode: 10 },
  { name: "Mont Ngafula", value: "084", regionCode: 10 },
  { name: "Ngaliema", value: "085", regionCode: 10 },

  // Kongo-Central (KC) - 11
  { name: "Matadi", value: "086", regionCode: 11 },
  { name: "Boma", value: "087", regionCode: 11 },
  { name: "Muanda", value: "088", regionCode: 11 },
  { name: "Songololo", value: "089", regionCode: 11 },
  { name: "Seke-Banza", value: "090", regionCode: 11 },
  { name: "Kasangulu", value: "091", regionCode: 11 },
  { name: "Madimba", value: "092", regionCode: 11 },
  { name: "Mbanza-Ngungu", value: "093", regionCode: 11 },
  { name: "Lukula", value: "094", regionCode: 11 },
  { name: "Tshela", value: "095", regionCode: 11 },

  // Kwango (KW) - 12
  { name: "Kenge", value: "096", regionCode: 12 },
  { name: "Kenge Territory", value: "097", regionCode: 12 },
  { name: "Kasongo-Lunda", value: "098", regionCode: 12 },
  { name: "Popokabaka", value: "099", regionCode: 12 },
  { name: "Feshi", value: "100", regionCode: 12 },
  { name: "Kahemba", value: "101", regionCode: 12 },

  // Kwilu (KL) - 13
  { name: "Bandundu", value: "102", regionCode: 13 },
  { name: "Bagata", value: "103", regionCode: 13 },
  { name: "Bulungu", value: "104", regionCode: 13 },
  { name: "Gungu", value: "105", regionCode: 13 },
  { name: "Idiofa", value: "106", regionCode: 13 },
  { name: "Kikwit", value: "107", regionCode: 13 },
  { name: "Mangai", value: "108", regionCode: 13 },
  { name: "Masi-Manimba", value: "109", regionCode: 13 },

  // Lomami (LO) - 14
  { name: "Kabinda", value: "110", regionCode: 14 },
  { name: "Lubao", value: "111", regionCode: 14 },
  { name: "Luilu", value: "112", regionCode: 14 },
  { name: "Ngandajika", value: "113", regionCode: 14 },

  // Lualaba (LU) - 15
  { name: "Kolwezi", value: "114", regionCode: 15 },
  { name: "Dilolo", value: "115", regionCode: 15 },
  { name: "Kapanga", value: "116", regionCode: 15 },
  { name: "Lubudi", value: "117", regionCode: 15 },
  { name: "Mutshatsha", value: "118", regionCode: 15 },
  { name: "Sandoa", value: "119", regionCode: 15 },

  // Mai-Ndombe (MN) - 16
  { name: "Inongo", value: "120", regionCode: 16 },
  { name: "Kiri", value: "121", regionCode: 16 },
  { name: "Kutu", value: "122", regionCode: 16 },
  { name: "Kwamouth", value: "123", regionCode: 16 },
  { name: "Bolobo", value: "124", regionCode: 16 },
  { name: "Mushie", value: "125", regionCode: 16 },
  { name: "Yumbi", value: "126", regionCode: 16 },

  // Maniema (MA) - 17
  { name: "Kindu", value: "127", regionCode: 17 },
  { name: "Kabambare", value: "128", regionCode: 17 },
  { name: "Kunda", value: "129", regionCode: 17 },
  { name: "Pangi", value: "130", regionCode: 17 },
  { name: "Kailo", value: "131", regionCode: 17 },

  // Mongala (MO) - 18
  { name: "Goma", value: "132", regionCode: 18 },
  { name: "Beni", value: "133", regionCode: 18 },
  { name: "Butembo", value: "134", regionCode: 18 },
  { name: "Lubero", value: "135", regionCode: 18 },
  { name: "Masisi", value: "136", regionCode: 18 },
  { name: "Nyiragongo", value: "137", regionCode: 18 },
  { name: "Rutshuru", value: "138", regionCode: 18 },
  { name: "Walikale", value: "139", regionCode: 18 },

  // Nord-Kivu (NK) - 19
  { name: "Goma", value: "140", regionCode: 19 },
  { name: "Beni", value: "141", regionCode: 19 },
  { name: "Butembo", value: "142", regionCode: 19 },
  { name: "Lubero", value: "143", regionCode: 19 },
  { name: "Masisi", value: "144", regionCode: 19 },
  { name: "Nyiragongo", value: "145", regionCode: 19 },
  { name: "Rutshuru", value: "146", regionCode: 19 },
  { name: "Walikale", value: "147", regionCode: 19 },

  // Nord-Ubangi (NU) - 20
  { name: "Gbadolite", value: "148", regionCode: 20 },
  { name: "Bosobolo", value: "149", regionCode: 20 },
  { name: "Businga", value: "150", regionCode: 20 },
  { name: "Mobayi-Mbongo", value: "151", regionCode: 20 },
  { name: "Yakoma", value: "152", regionCode: 20 },

  // Sankuru (SA) - 21
  { name: "Lusambo", value: "153", regionCode: 21 },
  { name: "Katako-Kombe", value: "154", regionCode: 21 },
  { name: "Kole", value: "155", regionCode: 21 },
  { name: "Lomela", value: "156", regionCode: 21 },
  { name: "Lubefu", value: "157", regionCode: 21 },
  { name: "Tshikapa", value: "158", regionCode: 21 },

  // Sud-Kivu (SK) - 22
  { name: "Bukavu", value: "159", regionCode: 22 },
  { name: "Uvira", value: "160", regionCode: 22 },
  { name: "Fizi", value: "161", regionCode: 22 },
  { name: "Mwenga", value: "162", regionCode: 22 },
  { name: "Shabunda", value: "163", regionCode: 22 },
  { name: "Walungu", value: "164", regionCode: 22 },
  { name: "Kabare", value: "165", regionCode: 22 },

  // Sud-Ubangi (SU) - 23
  { name: "Gemena", value: "166", regionCode: 23 },
  { name: "Budjala", value: "167", regionCode: 23 },
  { name: "Libenge", value: "168", regionCode: 23 },
  { name: "Zongo", value: "169", regionCode: 23 },

  // Tanganyika (TA) - 24
  { name: "Kalemie", value: "170", regionCode: 24 },
  { name: "Kabalo", value: "171", regionCode: 24 },
  { name: "Kongolo", value: "172", regionCode: 24 },
  { name: "Moba", value: "173", regionCode: 24 },
  { name: "Nyunzu", value: "174", regionCode: 24 },
  { name: "Manono", value: "175", regionCode: 24 },

  // Tshopo (TS) - 25
  { name: "Kisangani", value: "176", regionCode: 25 },
  { name: "Bafwasende", value: "177", regionCode: 25 },
  { name: "Banalia", value: "178", regionCode: 25 },
  { name: "Basoko", value: "179", regionCode: 25 },
  { name: "Isangi", value: "180", regionCode: 25 },
  { name: "Opala", value: "181", regionCode: 25 },
  { name: "Ubundu", value: "182", regionCode: 25 },

  // Tshuapa (TP) - 26
  { name: "Boende", value: "183", regionCode: 26 },
  { name: "Befale", value: "184", regionCode: 26 },
  { name: "Bokungu", value: "185", regionCode: 26 },
  { name: "Djolu", value: "186", regionCode: 26 },
  { name: "Ikela", value: "187", regionCode: 26 }
];

export const drcRegion = [
  { name: "Bas-Uélé", value: 1, code: "BU" },
  { name: "Équateur", value: 2, code: "EQ" },
  { name: "Haut-Katanga", value: 3, code: "HK" },
  { name: "Haut-Lomami", value: 4, code: "HL" },
  { name: "Haut-Uélé", value: 5, code: "HU" },
  { name: "Ituri", value: 6, code: "IT" },
  { name: "Kasaï", value: 7, code: "KS" },
  { name: "Kasaï-Central", value: 8, code: "KC" },
  { name: "Kasaï-Oriental", value: 9, code: "KE" },
  { name: "Kinshasa", value: 10, code: "KN" },
  { name: "Kongo-Central", value: 11, code: "KC" },
  { name: "Kwango", value: 12, code: "KW" },
  { name: "Kwilu", value: 13, code: "KL" },
  { name: "Lomami", value: 14, code: "LO" },
  { name: "Lualaba", value: 15, code: "LU" },
  { name: "Mai-Ndombe", value: 16, code: "MN" },
  { name: "Maniema", value: 17, code: "MA" },
  { name: "Mongala", value: 18, code: "MO" },
  { name: "Nord-Kivu", value: 19, code: "NK" },
  { name: "Nord-Ubangi", value: 20, code: "NU" },
  { name: "Sankuru", value: 21, code: "SA" },
  { name: "Sud-Kivu", value: 22, code: "SK" },
  { name: "Sud-Ubangi", value: 23, code: "SU" },
  { name: "Tanganyika", value: 24, code: "TA" },
  { name: "Tshopo", value: 25, code: "TS" },
  { name: "Tshuapa", value: 26, code: "TP" }
];
export const ethRegion = [
  { name: "Addis Ababa", value: 1, code: "01" },
  { name: "Afar", value: 2, code: "02" },
  { name: "Amhara", value: 3, code: "03" },
  { name: "Benishangul-Gumuz", value: 4, code: "04" },
  { name: "Dire Dawa", value: 5, code: "05" },
  { name: "Gambela", value: 6, code: "06" },
  { name: "Harari", value: 7, code: "07" },
  { name: "Oromia", value: 8, code: "08" },
  { name: "Sidama", value: 9, code: "09" },
  { name: "Somali", value: 10, code: "10" },
  { name: "Southern Nations (SNNPR)", value: 11, code: "11" },
  { name: "Tigray", value: 12, code: "12" }
];

export const ethMunicipality = [
  // Addis Ababa - 01
  { name: "Addis Ababa", value: "001", regionCode: 1 },
  
  // Afar - 02
  { name: "Asayita", value: "013", regionCode: 2 },
  { name: "Afambo", value: "014", regionCode: 2 },
  { name: "Dubti", value: "015", regionCode: 2 },
  { name: "Elidar", value: "016", regionCode: 2 },
  { name: "Berhale", value: "017", regionCode: 2 },
  { name: "Awash Fentale", value: "018", regionCode: 2 },
  { name: "Gewane", value: "019", regionCode: 2 },
  { name: "Amibara", value: "020", regionCode: 2 },
  { name: "Bure Mudaytu", value: "021", regionCode: 2 },
  { name: "Argoba", value: "022", regionCode: 2 },
  { name: "Dallol", value: "023", regionCode: 2 },
  { name: "Megale", value: "024", regionCode: 2 },
  { name: "Erebti", value: "025", regionCode: 2 },
  { name: "Teru", value: "026", regionCode: 2 },
  { name: "Hadaleala", value: "027", regionCode: 2 },
  { name: "Kori", value: "028", regionCode: 2 },
  { name: "Mille", value: "029", regionCode: 2 },
  { name: "Koneba", value: "030", regionCode: 2 },
  { name: "Dalifage", value: "031", regionCode: 2 },

  // Amhara - 03
  { name: "Dangila", value: "032", regionCode: 3 },
  { name: "Fagita Lekoma", value: "033", regionCode: 3 },
  { name: "Guangua", value: "034", regionCode: 3 },
  { name: "Injibara", value: "035", regionCode: 3 },
  { name: "Jawi", value: "036", regionCode: 3 },
  { name: "Kemekem", value: "037", regionCode: 3 },
  { name: "Aneded", value: "038", regionCode: 3 },
  { name: "Dabat", value: "039", regionCode: 3 },
  { name: "Debark", value: "040", regionCode: 3 },
  { name: "Wegera", value: "041", regionCode: 3 },
  { name: "Chilga", value: "042", regionCode: 3 },
  { name: "Metemma", value: "043", regionCode: 3 },
  { name: "Quara", value: "044", regionCode: 3 },
  { name: "Tach Armachiho", value: "045", regionCode: 3 },
  { name: "Alefa", value: "046", regionCode: 3 },
  { name: "Debre Tabor", value: "047", regionCode: 3 },
  { name: "Fogera", value: "048", regionCode: 3 },
  { name: "Libo Kemkem", value: "049", regionCode: 3 },
  { name: "Farta", value: "050", regionCode: 3 },
  { name: "Dera", value: "051", regionCode: 3 },
  { name: "Simada", value: "052", regionCode: 3 },
  { name: "Ebenat", value: "053", regionCode: 3 },
  { name: "Woldia", value: "054", regionCode: 3 },
  { name: "Kobo", value: "055", regionCode: 3 },
  { name: "Lalibela", value: "056", regionCode: 3 },
  { name: "Guba Lafto", value: "057", regionCode: 3 },
  { name: "Meket", value: "058", regionCode: 3 },
  { name: "Raya Kobo", value: "059", regionCode: 3 },
  { name: "Dessie", value: "060", regionCode: 3 },
  { name: "Kombolcha", value: "061", regionCode: 3 },
  { name: "Tehuledere", value: "062", regionCode: 3 },
  { name: "Wereilu", value: "063", regionCode: 3 },
  { name: "Kalu", value: "064", regionCode: 3 },
  { name: "Wuchale", value: "065", regionCode: 3 },
  { name: "Kutaber", value: "066", regionCode: 3 },
  { name: "Debre Markos", value: "067", regionCode: 3 },
  { name: "Machakel", value: "068", regionCode: 3 },
  { name: "Bibugn", value: "069", regionCode: 3 },
  { name: "Dejen", value: "070", regionCode: 3 },
  { name: "Lumame", value: "071", regionCode: 3 },
  { name: "Shebel Berenta", value: "072", regionCode: 3 },
  { name: "Finote Selam", value: "073", regionCode: 3 },
  { name: "Bure", value: "074", regionCode: 3 },
  { name: "Yilmana Densa", value: "075", regionCode: 3 },
  { name: "Jabi Tehnan", value: "076", regionCode: 3 },
  { name: "Mecha", value: "077", regionCode: 3 },
  { name: "Bahir Dar City", value: "078", regionCode: 3 },

  // Benishangul-Gumuz - 04
  { name: "Asosa", value: "079", regionCode: 4 },
  { name: "Sherkole", value: "080", regionCode: 4 },
  { name: "Bambasi", value: "081", regionCode: 4 },
  { name: "Menge", value: "082", regionCode: 4 },
  { name: "Kamashi", value: "083", regionCode: 4 },
  { name: "Agalo Mite", value: "084", regionCode: 4 },
  { name: "Hamer Bako", value: "085", regionCode: 4 },
  { name: "Gilgel Beles", value: "086", regionCode: 4 },
  { name: "Mandura", value: "087", regionCode: 4 },
  { name: "Pawe", value: "088", regionCode: 4 },
  { name: "Dangur", value: "089", regionCode: 4 },

  // Dire Dawa - 05
  { name: "Dire Dawa City", value: "090", regionCode: 5 },
  { name: "Dire Dawa Rural", value: "091", regionCode: 5 },

  // Gambela - 06
  { name: "Jikawo", value: "092", regionCode: 6 },
  { name: "Akobo", value: "093", regionCode: 6 },
  { name: "Makuey", value: "094", regionCode: 6 },
  { name: "Wentawo", value: "095", regionCode: 6 },
  { name: "Itang", value: "096", regionCode: 6 },
  { name: "Gog", value: "097", regionCode: 6 },
  { name: "Dimma", value: "098", regionCode: 6 },
  { name: "Abobo", value: "099", regionCode: 6 },

  // Harari - 07
  { name: "Amir Nur", value: "100", regionCode: 7 },
  { name: "Aboker", value: "101", regionCode: 7 },
  { name: "Shenkor", value: "102", regionCode: 7 },
  { name: "Hakim", value: "103", regionCode: 7 },
  { name: "Sofi", value: "104", regionCode: 7 },
  { name: "Jin'E", value: "106", regionCode: 7 },
  { name: "Erer", value: "107", regionCode: 7 },

  // Oromia - 08
  { name: "Adama", value: "109", regionCode: 8 },
  { name: "Bora", value: "110", regionCode: 8 },
  { name: "Lome", value: "111", regionCode: 8 },
  { name: "Dugda", value: "112", regionCode: 8 },
  { name: "Boset", value: "113", regionCode: 8 },
  { name: "Ambo", value: "114", regionCode: 8 },
  { name: "Dandi", value: "115", regionCode: 8 },
  { name: "Ginde Beret", value: "116", regionCode: 8 },
  { name: "Jeldu", value: "117", regionCode: 8 },
  { name: "Naannawa Ambo Town", value: "118", regionCode: 8 },
  { name: "Robe", value: "119", regionCode: 8 },
  { name: "Ginnir", value: "120", regionCode: 8 },
  { name: "Delo Mena", value: "121", regionCode: 8 },
  { name: "Agarfa", value: "122", regionCode: 8 },
  { name: "Asella", value: "123", regionCode: 8 },
  { name: "Digalu Tijo", value: "125", regionCode: 8 },
  { name: "Gololcha", value: "126", regionCode: 8 },
  { name: "Negele Borana", value: "127", regionCode: 8 },
  { name: "Bore", value: "128", regionCode: 8 },
  { name: "Uraga", value: "129", regionCode: 8 },
  { name: "Liben", value: "130", regionCode: 8 },
  { name: "Jimma", value: "131", regionCode: 8 },
  { name: "Agaro", value: "132", regionCode: 8 },
  { name: "Gomma", value: "133", regionCode: 8 },
  { name: "Limmu Kosa", value: "134", regionCode: 8 },
  { name: "Shashamane", value: "135", regionCode: 8 },
  { name: "Dodola", value: "136", regionCode: 8 },
  { name: "Tiyo", value: "137", regionCode: 8 },
  { name: "Harar", value: "138", regionCode: 8 },
  { name: "Haramaya", value: "139", regionCode: 8 },
  { name: "Kersa", value: "140", regionCode: 8 },
  { name: "Deder", value: "141", regionCode: 8 },
  { name: "Chiro", value: "142", regionCode: 8 },
  { name: "Gelemso", value: "143", regionCode: 8 },
  { name: "Guba Koricha", value: "144", regionCode: 8 },

  // Sidama - 09
  { name: "Aleta Chuko", value: "145", regionCode: 9 },
  { name: "Aleta Wendo", value: "146", regionCode: 9 },
  { name: "Aroresa", value: "147", regionCode: 9 },
  { name: "Bensa", value: "148", regionCode: 9 },
  { name: "Borra", value: "149", regionCode: 9 },
  { name: "Chere", value: "150", regionCode: 9 },
  { name: "Dara", value: "151", regionCode: 9 },
  { name: "Doyogena", value: "152", regionCode: 9 },
  { name: "Hula", value: "153", regionCode: 9 },
  { name: "Loka Abaya", value: "154", regionCode: 9 },
  { name: "Malga", value: "155", regionCode: 9 },
  { name: "Wensho", value: "156", regionCode: 9 },
  { name: "Shebedino", value: "157", regionCode: 9 },
  { name: "Wolayita Sodo", value: "158", regionCode: 9 },
  { name: "Hawassa City", value: "159", regionCode: 9 },

  // Somali - 10
  { name: "Jigjiga Town", value: "160", regionCode: 10 },
  { name: "Awbare", value: "161", regionCode: 10 },
  { name: "Kebri Beyah", value: "162", regionCode: 10 },
  { name: "Fafan", value: "163", regionCode: 10 },
  { name: "Degehabur", value: "164", regionCode: 10 },
  { name: "Gunagado", value: "165", regionCode: 10 },
  { name: "Hudet", value: "166", regionCode: 10 },
  { name: "Danan", value: "167", regionCode: 10 },
  { name: "Kebri Dahar", value: "168", regionCode: 10 },
  { name: "Shilabo", value: "169", regionCode: 10 },
  { name: "Adadle", value: "170", regionCode: 10 },
  { name: "Harshin", value: "171", regionCode: 10 },
  { name: "Dembel", value: "172", regionCode: 10 },
  { name: "Duhun", value: "173", regionCode: 10 },
  { name: "Gode", value: "174", regionCode: 10 },
  { name: "Dolobay", value: "175", regionCode: 10 },
  { name: "Hargelle", value: "176", regionCode: 10 },
  { name: "Moyale", value: "177", regionCode: 10 },
  { name: "Dolo", value: "178", regionCode: 10 },
  { name: "Filtu", value: "179", regionCode: 10 },
  { name: "Shinile", value: "180", regionCode: 10 },
  { name: "Afdem", value: "181", regionCode: 10 },
  { name: "Mieso", value: "182", regionCode: 10 },
  { name: "Misraq Gashamo", value: "183", regionCode: 10 },
  { name: "Bilcil", value: "184", regionCode: 10 },

  // Southern Nations (SNNPR) - 11
  { name: "Arba Minch Zuria", value: "185", regionCode: 11 },
  { name: "Chencha", value: "186", regionCode: 11 },
  { name: "Dita Dermalo", value: "187", regionCode: 11 },
  { name: "Kemba", value: "188", regionCode: 11 },
  { name: "Bonk", value: "189", regionCode: 11 },
  { name: "Dila Town", value: "190", regionCode: 11 },
  { name: "Wenago", value: "191", regionCode: 11 },
  { name: "Bule", value: "192", regionCode: 11 },
  { name: "Yirgachefe", value: "193", regionCode: 11 },
  { name: "Hossana", value: "194", regionCode: 11 },
  { name: "Limo", value: "195", regionCode: 11 },
  { name: "Mirab Azernet Berbere", value: "196", regionCode: 11 },
  { name: "Soro", value: "197", regionCode: 11 },
  { name: "Durame", value: "198", regionCode: 11 },
  { name: "Angacha", value: "199", regionCode: 11 },
  { name: "Doyogena", value: "200", regionCode: 11 },
  { name: "Kacha Bira", value: "201", regionCode: 11 },
  { name: "Sodo Town", value: "202", regionCode: 11 },
  { name: "Damot Gale", value: "203", regionCode: 11 },
  { name: "Damot Woide", value: "204", regionCode: 11 },
  { name: "Boloso Sore", value: "205", regionCode: 11 },
  { name: "Worabe Town", value: "206", regionCode: 11 },
  { name: "Alicho Werero", value: "207", regionCode: 11 },
  { name: "Lanfro", value: "208", regionCode: 11 },
  { name: "Jinka", value: "209", regionCode: 11 },
  { name: "Benatsemay", value: "210", regionCode: 11 },
  { name: "Hamer", value: "211", regionCode: 11 },
  { name: "Nyangatom", value: "212", regionCode: 11 },
  { name: "Mizan Aman", value: "213", regionCode: 11 },
  { name: "Bonga", value: "214", regionCode: 11 },
  { name: "Tepi", value: "215", regionCode: 11 },
  { name: "Decha", value: "217", regionCode: 11 },
  { name: "Gimbo", value: "218", regionCode: 11 },
  { name: "Tarcha", value: "219", regionCode: 11 },
  { name: "Loma", value: "220", regionCode: 11 },
  { name: "Sheko", value: "222", regionCode: 11 },
  { name: "Surma", value: "223", regionCode: 11 },

  // Tigray - 12
  { name: "Mekelle", value: "224", regionCode: 12 },
  { name: "Hawzen", value: "225", regionCode: 12 },
  { name: "Kilte Awulaelo", value: "226", regionCode: 12 },
  { name: "Saesi Tsaedaemba", value: "227", regionCode: 12 },
  { name: "Degua Tembien", value: "228", regionCode: 12 },
  { name: "Hintalo Wajirat", value: "229", regionCode: 12 },
  { name: "Adigrat", value: "230", regionCode: 12 },
  { name: "Gulomahda", value: "231", regionCode: 12 },
  { name: "Kola Tembien", value: "232", regionCode: 12 },
  { name: "Wukro", value: "233", regionCode: 12 },
  { name: "Shire", value: "234", regionCode: 12 },
  { name: "Tselemti", value: "235", regionCode: 12 },
  { name: "Tahtay Adiyabo", value: "236", regionCode: 12 },
  { name: "Asgede Tsimbila", value: "237", regionCode: 12 },
  { name: "Alamata", value: "238", regionCode: 12 },
  { name: "Ofla", value: "239", regionCode: 12 },
  { name: "Raya Azebo", value: "240", regionCode: 12 },
  { name: "Endamehoni", value: "241", regionCode: 12 },
  { name: "La'ilai Adyabo", value: "242", regionCode: 12 },
  { name: "Welkait", value: "243", regionCode: 12 },
  { name: "Tahtay Koraro", value: "244", regionCode: 12 }
];
export const ivorianMunicipality = [
  // Abidjan (AB) - 01
  { name: "Abidjan", value: "001", regionCode: 1 },

  // Yamoussoukro (YS) - 02
  { name: "Yamoussoukro", value: "002", regionCode: 2 },

  // Bas-Sassandra (BS) - 03
  { name: "San-Pédro", value: "003", regionCode: 3 },
  { name: "Nawa", value: "004", regionCode: 3 },
  { name: "Gbôklé", value: "005", regionCode: 3 },

  // Comoé (CM) - 04
  { name: "Sud-Comoé", value: "006", regionCode: 4 },
  { name: "Indénié-Djuablin", value: "007", regionCode: 4 },

  // Denguélé (DG) - 05
  { name: "Denguélé", value: "008", regionCode: 5 },
  { name: "Folon", value: "009", regionCode: 5 },
  { name: "Kabadougou", value: "010", regionCode: 5 },

  // Gôh-Djiboua (GD) - 06
  { name: "Gôh", value: "011", regionCode: 6 },
  { name: "Lôh-Djiboua", value: "012", regionCode: 6 },

  // Lacs (LC) - 07
  { name: "Bélier", value: "013", regionCode: 7 },
  { name: "Iffou", value: "014", regionCode: 7 },
  { name: "Moronou", value: "015", regionCode: 7 },
  { name: "N'Zi", value: "016", regionCode: 7 },
  { name: "Grands-Ponts", value: "018", regionCode: 7 },
  { name: "La Mé", value: "019", regionCode: 7 },

  // Lagunes (LG) - 08
  { name: "Agnéby-Tiassa", value: "017", regionCode: 8 },

  // Montagnes (MT) - 09
  { name: "Cavally", value: "020", regionCode: 9 },
  { name: "Guémon", value: "021", regionCode: 9 },
  { name: "Tonkpi", value: "022", regionCode: 9 },

  // Sassandra-Marahoué (SM) - 10
  { name: "Haut-Sassandra", value: "023", regionCode: 10 },
  { name: "Marahoué", value: "024", regionCode: 10 },

  // Savanes (SV) - 11
  { name: "Bagoué", value: "025", regionCode: 11 },
  { name: "Poro", value: "026", regionCode: 11 },
  { name: "Tchologo", value: "027", regionCode: 11 },

  // Vallée du Bandama (VB) - 12
  { name: "Gbêkê", value: "028", regionCode: 12 },
  { name: "Hambol", value: "029", regionCode: 12 },

  // Woroba (WO) - 13
  { name: "Bafing", value: "030", regionCode: 13 },
  { name: "Béré", value: "031", regionCode: 13 },
  { name: "Worodougou", value: "032", regionCode: 13 },

  // Zanzan (ZZ) - 14
  { name: "Bounkani", value: "033", regionCode: 14 },
  { name: "Gontougo", value: "034", regionCode: 14 },
];
export const ivorianRegion = [
  { name: "Abidjan", value: 1, code: "AB" },
  { name: "Yamoussoukro", value: 2, code: "YS" },
  { name: "Bas-Sassandra", value: 3, code: "BS" },
  { name: "Comoé", value: 4, code: "CM" },
  { name: "Denguélé", value: 5, code: "DG" },
  { name: "Gôh-Djiboua", value: 6, code: "GD" },
  { name: "Lacs", value: 7, code: "LC" },
  { name: "Lagunes", value: 8, code: "LG" },
  { name: "Montagnes", value: 9, code: "MT" },
  { name: "Sassandra-Marahoué", value: 10, code: "SM" },
  { name: "Savanes", value: 11, code: "SV" },
  { name: "Vallée du Bandama", value: 12, code: "VB" },
  { name: "Woroba", value: 13, code: "WO" },
  { name: "Zanzan", value: 14, code: "ZZ" },
];
export const ghanaRegions = [
  { name: "WESTERN", value: 1 },
  { name: "CENTRAL", value: 2 },
  { name: "GREATER ACCRA", value: 3 },
  { name: "VOLTA", value: 4 },
  { name: "EASTERN", value: 5 },
  { name: "ASHANTI", value: 6 },
  { name: "WESTERN NORTH", value: 7 },
  { name: "AHAFO", value: 8 },
  { name: "BONO", value: 9 },
  { name: "BONO EAST", value: 10 },
  { name: "OTI", value: 11 },
  { name: "NORTHERN", value: 12 },
  { name: "SAVANNAH", value: 13 },
  { name: "UPPER WEST", value: 14 },
  { name: "NORTH EAST", value: 15 },
  { name: "UPPER EAST", value: 16 }
];

export const ghanaMunicipality = [
  // WESTERN (1)
  { name: "JOMORO", value: "A0101", regionCode: 1 },
  { name: "ELLEMBELE", value: "A0201", regionCode: 1 },
  { name: "EVALUE AJOMORO GWIRA", value: "A0301", regionCode: 1 },
  { name: "AHANTA WEST", value: "A0401", regionCode: 1 },
  { name: "TAKORADI", value: "A0501", regionCode: 1 },
  { name: "SEKONDI", value: "A0502", regionCode: 1 },
  { name: "ESSIKADU-KETAN", value: "A0503", regionCode: 1 },
  { name: "EFFIA", value: "A0601", regionCode: 1 },
  { name: "KWESIMINTIM", value: "A0602", regionCode: 1 },
  { name: "SHAMA", value: "A0701", regionCode: 1 },
  { name: "WASSA EAST", value: "A0801", regionCode: 1 },
  { name: "MPOHOR", value: "A0901", regionCode: 1 },
  { name: "TARKWA NSUAEM", value: "A1001", regionCode: 1 },
  { name: "PRESTEA HUNI-VALLEY", value: "A1101", regionCode: 1 },
  { name: "WASSA AMENFI EAST", value: "A1201", regionCode: 1 },
  { name: "AMENFI CENTRAL", value: "A1301", regionCode: 1 },
  { name: "AMENFI WEST", value: "A1401", regionCode: 1 },

  // CENTRAL (2)
  { name: "KOMENDA EDINA EGUAFO ABREM", value: "B0101", regionCode: 2 },
  { name: "CAPE COAST SOUTH", value: "B0201", regionCode: 2 },
  { name: "CAPE COAST NORTH", value: "B0202", regionCode: 2 },
  { name: "ABURA/ASEBU/KWAMANKESE", value: "B0301", regionCode: 2 },
  { name: "MFANTSEMAN", value: "B0401", regionCode: 2 },
  { name: "EKUMFI", value: "B0501", regionCode: 2 },
  { name: "AJUMAKO ENYAN ESIAM", value: "B0601", regionCode: 2 },
  { name: "GOMOA WEST", value: "B0701", regionCode: 2 },
  { name: "GOMOA CENTRAL", value: "B0801", regionCode: 2 },
  { name: "GOMOA EAST", value: "B0901", regionCode: 2 },
  { name: "EFFUTU", value: "B1001", regionCode: 2 },
  { name: "AWUTU SENYA WEST", value: "B1101", regionCode: 2 },
  { name: "AWUTU SENYA EAST", value: "B1201", regionCode: 2 },
  { name: "AGONA WEST", value: "B1301", regionCode: 2 },
  { name: "AGONA EAST", value: "B1401", regionCode: 2 },
  { name: "ASIKUMA/ODOBEN/BRAKWA", value: "B1501", regionCode: 2 },
  { name: "ASSIN CENTRAL", value: "B1601", regionCode: 2 },
  { name: "ASSIN NORTH", value: "B1701", regionCode: 2 },
  { name: "ASSIN SOUTH", value: "B1801", regionCode: 2 },
  { name: "TWIFO ATTI MORKWA", value: "B1901", regionCode: 2 },
  { name: "HEMANG LOWER DENKYIRA", value: "B2001", regionCode: 2 },
  { name: "UPPER DENKYIRA EAST", value: "B2101", regionCode: 2 },
  { name: "UPPER DENKYIRA WEST", value: "B2201", regionCode: 2 },

  // GREATER ACCRA (3)
  { name: "BORTIANOR-NGLESHIE AMANFRO", value: "C0101", regionCode: 3 },
  { name: "DOMEABRA/OBOM", value: "C0102", regionCode: 3 },
  { name: "WEIJA / GBAWE", value: "C0201", regionCode: 3 },
  { name: "ANYAA/SOWUTUOM", value: "C0301", regionCode: 3 },
  { name: "TROBU", value: "C0401", regionCode: 3 },
  { name: "AMASAMAN", value: "C0501", regionCode: 3 },
  { name: "DOME/KWABENYA", value: "C0601", regionCode: 3 },
  { name: "MADINA", value: "C0701", regionCode: 3 },
  { name: "AYAWASO EAST", value: "C0801", regionCode: 3 },
  { name: "AYAWASO NORTH", value: "C0901", regionCode: 3 },
  { name: "AYAWASO CENTRAL", value: "C1001", regionCode: 3 },
  { name: "AYAWASO WEST WUOGON", value: "C1101", regionCode: 3 },
  { name: "OKAIKWEI SOUTH", value: "C1201", regionCode: 3 },
  { name: "ABLEKUMA SOUTH", value: "C1202", regionCode: 3 },
  { name: "ODODODIODIOO", value: "C1203", regionCode: 3 },
  { name: "OKAIKWEI CENTRAL", value: "C1301", regionCode: 3 },
  { name: "OKAIKWEI NORTH", value: "C1302", regionCode: 3 },
  { name: "ABLEKUMA NORTH", value: "C1401", regionCode: 3 },
  { name: "ABLEKUMA CENTRAL", value: "C1501", regionCode: 3 },
  { name: "ABLEKUMA WEST", value: "C1601", regionCode: 3 },
  { name: "KORLE KLOTTEY", value: "C1701", regionCode: 3 },
  { name: "DADEKOTOPON", value: "C1801", regionCode: 3 },
  { name: "LEDZOKUKU", value: "C1901", regionCode: 3 },
  { name: "KROWOR", value: "C2001", regionCode: 3 },
  { name: "TEMA EAST", value: "C2101", regionCode: 3 },
  { name: "TEMA CENTRAL", value: "C2102", regionCode: 3 },
  { name: "TEMA-WEST", value: "C2201", regionCode: 3 },
  { name: "KPONE KATAMANSO", value: "C2301", regionCode: 3 },
  { name: "ASHAIMAN", value: "C2401", regionCode: 3 },
  { name: "ADENTAN", value: "C2501", regionCode: 3 },
  { name: "SHAI- OSUDOKU", value: "C2601", regionCode: 3 },
  { name: "NINGO PRAMPRAM", value: "C2701", regionCode: 3 },
  { name: "SEGE", value: "C2801", regionCode: 3 },
  { name: "ADA", value: "C2901", regionCode: 3 },

  // VOLTA (4)
  { name: "KETA", value: "D0101", regionCode: 4 },
  { name: "ANLO", value: "D0201", regionCode: 4 },
  { name: "KETU SOUTH", value: "D0301", regionCode: 4 },
  { name: "KETU NORTH", value: "D0401", regionCode: 4 },
  { name: "AKATSI SOUTH", value: "D0501", regionCode: 4 },
  { name: "AKATSI NORTH", value: "D0601", regionCode: 4 },
  { name: "SOUTH TONGU", value: "D0701", regionCode: 4 },
  { name: "CENTRAL TONGU", value: "D0801", regionCode: 4 },
  { name: "NORTH TONGU", value: "D0901", regionCode: 4 },
  { name: "ADAKLU", value: "D1001", regionCode: 4 },
  { name: "AGOTIME-ZIOPE", value: "D1101", regionCode: 4 },
  { name: "HO CENTRAL", value: "D1201", regionCode: 4 },
  { name: "HO WEST", value: "D1301", regionCode: 4 },
  { name: "SOUTH DAYI", value: "D1401", regionCode: 4 },
  { name: "KPANDO", value: "D1501", regionCode: 4 },
  { name: "NORTH DAYI", value: "D1601", regionCode: 4 },
  { name: "HOHOE", value: "D1701", regionCode: 4 },
  { name: "AFADJATO SOUTH", value: "D1801", regionCode: 4 },

  // EASTERN (5)
  { name: "ASUOGYAMAN", value: "E0101", regionCode: 5 },
  { name: "LOWER MANYA KROBO", value: "E0201", regionCode: 5 },
  { name: "UPPER MANYA KROBO", value: "E0301", regionCode: 5 },
  { name: "YILO KROBO", value: "E0401", regionCode: 5 },
  { name: "NEW JUABEN SOUTH", value: "E0501", regionCode: 5 },
  { name: "NEW JUABEN NORTH", value: "E0601", regionCode: 5 },
  { name: "AKROPONG", value: "E0701", regionCode: 5 },
  { name: "OKERE", value: "E0801", regionCode: 5 },
  { name: "AKUAPEM SOUTH", value: "E0901", regionCode: 5 },
  { name: "NSAWAM/ADOAGYIRI", value: "E1001", regionCode: 5 },
  { name: "SUHUM", value: "E1101", regionCode: 5 },
  { name: "AYENSUANO", value: "E1201", regionCode: 5 },
  { name: "LOWER WEST AKIM", value: "E1301", regionCode: 5 },
  { name: "UPPER WEST AKIM", value: "E1401", regionCode: 5 },
  { name: "AKIM ODA", value: "E1501", regionCode: 5 },
  { name: "ASENE/AKROSO/MANSO", value: "E1601", regionCode: 5 },
  { name: "AKIM SWEDRU", value: "E1701", regionCode: 5 },
  { name: "ACHIASE", value: "E1801", regionCode: 5 },
  { name: "OFOASE/AYIREBI", value: "E1901", regionCode: 5 },
  { name: "KADE", value: "E2001", regionCode: 5 },
  { name: "AKWATIA", value: "E2101", regionCode: 5 },
  { name: "ABIREM", value: "E2201", regionCode: 5 },
  { name: "ABUAKWA SOUTH", value: "E2301", regionCode: 5 },
  { name: "ABUAKWA NORTH", value: "E2401", regionCode: 5 },
  { name: "ATIWA WEST", value: "E2501", regionCode: 5 },
  { name: "ATIWA EAST", value: "E2601", regionCode: 5 },
  { name: "FANTEAKWA NORTH", value: "E2701", regionCode: 5 },
  { name: "FANTEAKWA SOUTH", value: "E2801", regionCode: 5 },
  { name: "NKAWKAW", value: "E2901", regionCode: 5 },
  { name: "MPRAESO", value: "E3001", regionCode: 5 },
  { name: "ABETIFI", value: "E3101", regionCode: 5 },
  { name: "AFRAM PLAINS NORTH", value: "E3201", regionCode: 5 },
  { name: "AFRAM PLAINS SOUTH", value: "E3301", regionCode: 5 },

  // ASHANTI (6)
  { name: "NEW EDUBIASE", value: "F0101", regionCode: 6 },
  { name: "AKROFUOM", value: "F0201", regionCode: 6 },
  { name: "FOMENA", value: "F0301", regionCode: 6 },
  { name: "ADANSI ASOKWA", value: "F0401", regionCode: 6 },
  { name: "OBUASI WEST", value: "F0501", regionCode: 6 },
  { name: "OBUASI EAST", value: "F0601", regionCode: 6 },
  { name: "BEKWAI", value: "F0701", regionCode: 6 },
  { name: "BOSOME FREHO", value: "F0801", regionCode: 6 },
  { name: "ODOTOBIRI", value: "F0901", regionCode: 6 },
  { name: "MANSO NKWANTA", value: "F1001", regionCode: 6 },
  { name: "MANSO ADUBIA", value: "F1101", regionCode: 6 },
  { name: "ATWIMA NWABIAGYA SOUTH", value: "F1201", regionCode: 6 },
  { name: "ATWIMA NWABIAGYA NORTH", value: "F1301", regionCode: 6 },
  { name: "ATWIMA MPONUA", value: "F1401", regionCode: 6 },
  { name: "BOSOMTWE", value: "F1501", regionCode: 6 },
  { name: "ATWIMA KWANWOMA", value: "F1601", regionCode: 6 },
  { name: "BANTAMA", value: "F1701", regionCode: 6 },
  { name: "NHYIAESO", value: "F1702", regionCode: 6 },
  { name: "MANHYIA SOUTH", value: "F1703", regionCode: 6 },
  { name: "MANHYIA NORTH", value: "F1704", regionCode: 6 },
  { name: "SUBIN", value: "F1705", regionCode: 6 },
  { name: "KWADASO", value: "F1801", regionCode: 6 },
  { name: "OLD TAFO", value: "F1901", regionCode: 6 },
  { name: "SUAME", value: "F2001", regionCode: 6 },
  { name: "ASOKWA", value: "F2101", regionCode: 6 },
  { name: "OFORIKROM", value: "F2201", regionCode: 6 },
  { name: "ASAWASE", value: "F2301", regionCode: 6 },
  { name: "KWABRE EAST", value: "F2401", regionCode: 6 },
  { name: "AFIGYA KWABRE SOUTH", value: "F2501", regionCode: 6 },
  { name: "AFIGYA KWABRE NORTH", value: "F2601", regionCode: 6 },
  { name: "JUABEN", value: "F2701", regionCode: 6 },
  { name: "EJISU", value: "F2801", regionCode: 6 },
  { name: "ASANTE AKIM SOUTH", value: "F2901", regionCode: 6 },
  { name: "ASANTE AKIM CENTRAL", value: "F3001", regionCode: 6 },
  { name: "ASANTE AKIM NORTH", value: "F3101", regionCode: 6 },
  { name: "EFFIDUASE / ASOKORE", value: "F3201", regionCode: 6 },
  { name: "KUMAWU", value: "F3301", regionCode: 6 },
  { name: "SEKYERE AFRAM PLAINS", value: "F3401", regionCode: 6 },
  { name: "NSUTA/KWAMANG/BEPOSO", value: "F3501", regionCode: 6 },
  { name: "MAMPONG", value: "F3601", regionCode: 6 },
  { name: "EJURA SEKYEDUMASE", value: "F3701", regionCode: 6 },
  { name: "AFIGYA SEKYERE EAST", value: "F3801", regionCode: 6 },
  { name: "OFFINSO SOUTH", value: "F3901", regionCode: 6 },
  { name: "OFFINSO NORTH", value: "F4001", regionCode: 6 },
  { name: "AHAFO ANO SOUTH WEST", value: "F4101", regionCode: 6 },
  { name: "AHAFO ANO SOUTH EAST", value: "F4201", regionCode: 6 },
  { name: "AHAFO ANO NORTH", value: "F4301", regionCode: 6 },

  // WESTERN NORTH (7)
  { name: "AOWIN", value: "G0101", regionCode: 7 },
  { name: "SUAMAN", value: "G0201", regionCode: 7 },
  { name: "BIBIANI-ANHWIASO-BEKWAI", value: "G0301", regionCode: 7 },
  { name: "SEFWI WIAWSO", value: "G0401", regionCode: 7 },
  { name: "SEFWI AKONTOMBRA", value: "G0501", regionCode: 7 },
  { name: "JUABOSO", value: "G0601", regionCode: 7 },
  { name: "BODI", value: "G0701", regionCode: 7 },
  { name: "BIA WEST", value: "G0801", regionCode: 7 },
  { name: "BIA EAST", value: "G0901", regionCode: 7 },

  // AHAFO (8)
  { name: "ASUNAFO SOUTH", value: "H0101", regionCode: 8 },
  { name: "ASUNAFO NORTH", value: "H0201", regionCode: 8 },
  { name: "ASUTIFI SOUTH", value: "H0301", regionCode: 8 },
  { name: "ASUTIFI NORTH", value: "H0401", regionCode: 8 },
  { name: "TANO SOUTH", value: "H0501", regionCode: 8 },
  { name: "TANO NORTH", value: "H0601", regionCode: 8 },

  // BONO (9)
  { name: "SUNYANI EAST", value: "J0101", regionCode: 9 },
  { name: "SUNYANI WEST", value: "J0201", regionCode: 9 },
  { name: "DORMAA WEST", value: "J0301", regionCode: 9 },
  { name: "DORMAA CENTRAL", value: "J0401", regionCode: 9 },
  { name: "DORMAA EAST", value: "J0501", regionCode: 9 },
  { name: "BEREKUM EAST", value: "J0601", regionCode: 9 },
  { name: "BEREKUM WEST", value: "J0701", regionCode: 9 },
  { name: "JAMAN SOUTH", value: "J0801", regionCode: 9 },
  { name: "JAMAN NORTH", value: "J0901", regionCode: 9 },
  { name: "BANDA", value: "J1001", regionCode: 9 },
  { name: "TAIN", value: "J1101", regionCode: 9 },
  { name: "WENCHI", value: "J1201", regionCode: 9 },

  // BONO EAST (10)
  { name: "TECHIMAN", value: "K0101", regionCode: 10 },
  { name: "KINTAMPO NORTH", value: "K0201", regionCode: 10 },
  { name: "KINTAMPO SOUTH", value: "K0301", regionCode: 10 },
  { name: "NKORANZA NORTH", value: "K0401", regionCode: 10 },
  { name: "NKORANZA SOUTH", value: "K0501", regionCode: 10 },
  { name: "ATEBUBU/AMANTIN", value: "K0601", regionCode: 10 },
  { name: "PRU WEST", value: "K0701", regionCode: 10 },
  { name: "PRU EAST", value: "K0801", regionCode: 10 },
  { name: "SENE WEST", value: "K0901", regionCode: 10 },
  { name: "SENE EAST", value: "K1001", regionCode: 10 },
  { name: "TECHIMAN NORTH", value: "K1101", regionCode: 10 },

  // OTI (11)
  { name: "BUEM", value: "L0101", regionCode: 11 },
  { name: "BIAKOYE", value: "L0201", regionCode: 11 },
  { name: "AKAN", value: "L0301", regionCode: 11 },
  { name: "KRACHI EAST", value: "L0401", regionCode: 11 },
  { name: "KRACHI WEST", value: "L0501", regionCode: 11 },
  { name: "KRACHI-NCHUMURU", value: "L0601", regionCode: 11 },
  { name: "NKWANTA SOUTH", value: "L0701", regionCode: 11 },
  { name: "NKWANTA NORTH", value: "L0801", regionCode: 11 },

  // NORTHERN (12)
  { name: "KPANDAI", value: "M0101", regionCode: 12 },
  { name: "BIMBILLA", value: "M0201", regionCode: 12 },
  { name: "WULENSI", value: "M0301", regionCode: 12 },
  { name: "ZABZUGU", value: "M0401", regionCode: 12 },
  { name: "TATALE/SANGULI", value: "M0501", regionCode: 12 },
  { name: "YENDI", value: "M0601", regionCode: 12 },
  { name: "MION", value: "M0701", regionCode: 12 },
  { name: "SABOBA", value: "M0801", regionCode: 12 },
  { name: "GUSHEGU", value: "M0901", regionCode: 12 },
  { name: "KARAGA", value: "M1001", regionCode: 12 },
  { name: "SAVELUGU", value: "M1101", regionCode: 12 },
  { name: "NANTON", value: "M1201", regionCode: 12 },
  { name: "TAMALE SOUTH", value: "M1301", regionCode: 12 },
  { name: "TAMALE CENTRAL", value: "M1302", regionCode: 12 },
  { name: "SAGNARIGU", value: "M1401", regionCode: 12 },
  { name: "TAMALE NORTH", value: "M1402", regionCode: 12 },
  { name: "TOLON", value: "M1501", regionCode: 12 },
  { name: "KUMBUNGU", value: "M1601", regionCode: 12 },

  // SAVANNAH (13)
  { name: "BOLE/BAMBOI", value: "N0101", regionCode: 13 },
  { name: "SAWLA TUNA KALBA", value: "N0201", regionCode: 13 },
  { name: "DAMONGO", value: "N0301", regionCode: 13 },
  { name: "DABOYA/MANKARIGU", value: "N0401", regionCode: 13 },
  { name: "YAPEI-KUSAWGU", value: "N0501", regionCode: 13 },
  { name: "SALAGA SOUTH", value: "N0601", regionCode: 13 },
  { name: "SALAGA NORTH", value: "N0701", regionCode: 13 },

  // UPPER WEST (14)
  { name: "WA CENTRAL", value: "P0101", regionCode: 14 },
  { name: "WA WEST", value: "P0201", regionCode: 14 },
  { name: "WA EAST", value: "P0301", regionCode: 14 },
  { name: "NADOWLI/KALEO", value: "P0401", regionCode: 14 },
  { name: "DAFFIAMA/BUSSIE/ISSA", value: "P0501", regionCode: 14 },
  { name: "JIRAPA", value: "P0601", regionCode: 14 },
  { name: "LAMBUSSIE", value: "P0701", regionCode: 14 },
  { name: "LAWRA", value: "P0801", regionCode: 14 },
  { name: "NANDOM", value: "P0901", regionCode: 14 },
  { name: "SISSALA WEST", value: "P1001", regionCode: 14 },
  { name: "SISSALA EAST", value: "P1101", regionCode: 14 },

  // NORTH EAST (15)
  { name: "WALEWALE", value: "Q0101", regionCode: 15 },
  { name: "YAGABA /KUBORI", value: "Q0201", regionCode: 15 },
  { name: "NALERIGU / GAMBAGA", value: "Q0301", regionCode: 15 },
  { name: "BUNKPURUGU", value: "Q0401", regionCode: 15 },
  { name: "YUNYOO", value: "Q0501", regionCode: 15 },
  { name: "CHEREPONI", value: "Q0601", regionCode: 15 },

  // UPPER EAST (16)
  { name: "BUILSA SOUTH", value: "R0101", regionCode: 16 },
  { name: "BUILSA NORTH", value: "R0201", regionCode: 16 },
  { name: "KASSENA/NANKANA EAST", value: "R0301", regionCode: 16 },
  { name: "KASSENA/NANKANA WEST", value: "R0401", regionCode: 16 },
  { name: "BOLGATANGA CENTRAL", value: "R0501", regionCode: 16 },
  { name: "BOLGATANGA EAST", value: "R0601", regionCode: 16 },
  { name: "BONGO", value: "R0701", regionCode: 16 },
  { name: "TALENSI", value: "R0801", regionCode: 16 },
  { name: "NABDAM", value: "R0901", regionCode: 16 },
  { name: "BAWKU WEST", value: "R1001", regionCode: 16 },
  { name: "BAWKU", value: "R1101", regionCode: 16 },
  { name: "PUSIGA", value: "R1201", regionCode: 16 },
  { name: "GARU", value: "R1301", regionCode: 16 },
  { name: "TEMPANE", value: "R1401", regionCode: 16 },
  { name: "BINDURI", value: "R1501", regionCode: 16 }
];

export const mozambiqueRegions = [
  { name: "Cabo Delgado", value: 1 },
  { name: "Gaza", value: 2 },
  { name: "Inhambane", value: 3 },
  { name: "Manica", value: 4 },
  { name: "Maputo City", value: 5 },
  { name: "Maputo", value: 6 },
  { name: "Nampula", value: 7 },
  { name: "Niassa", value: 8 },
  { name: "Sofala", value: 9 },
  { name: "Tete", value: 10 },
  { name: "Zambezia", value: 11 }
];

export const mozambiqueMunicipality = [
  // Cabo Delgado (1)
  { name: "Ancuabe", value: "001", provinceCode: 1 },
  { name: "Balama", value: "002", provinceCode: 1 },
  { name: "Chiúre", value: "003", provinceCode: 1 },
  { name: "Ibo", value: "004", provinceCode: 1 },
  { name: "Macomia", value: "005", provinceCode: 1 },
  { name: "Mecúfi", value: "006", provinceCode: 1 },
  { name: "Meluco", value: "007", provinceCode: 1 },
  { name: "Metuge", value: "008", provinceCode: 1 },
  { name: "Mocímboa da Praia", value: "009", provinceCode: 1 },
  { name: "Montepuez", value: "010", provinceCode: 1 },
  { name: "Mueda", value: "011", provinceCode: 1 },
  { name: "Muidumbe", value: "012", provinceCode: 1 },
  { name: "Namuno", value: "013", provinceCode: 1 },
  { name: "Nangade", value: "014", provinceCode: 1 },
  { name: "Palma", value: "015", provinceCode: 1 },
  { name: "Pemba-Metuge (includes Pemba city)", value: "016", provinceCode: 1 },
  { name: "Quissanga", value: "017", provinceCode: 1 },
  
  // Gaza (2)
  { name: "Bilene Macia", value: "018", provinceCode: 2 },
  { name: "Chibuto", value: "019", provinceCode: 2 },
  { name: "Chicualacuala", value: "020", provinceCode: 2 },
  { name: "Chigubo", value: "021", provinceCode: 2 },
  { name: "Chókwè", value: "022", provinceCode: 2 },
  { name: "Guijá", value: "023", provinceCode: 2 },
  { name: "Mabalane", value: "024", provinceCode: 2 },
  { name: "Manjacaze", value: "025", provinceCode: 2 },
  { name: "Massangena", value: "026", provinceCode: 2 },
  { name: "Massingir", value: "027", provinceCode: 2 },
  { name: "Xai-Xai", value: "028", provinceCode: 2 },
  
  // Inhambane (3)
  { name: "Funhalouro", value: "029", provinceCode: 3 },
  { name: "Govuro", value: "030", provinceCode: 3 },
  { name: "Homoine", value: "031", provinceCode: 3 },
  { name: "Inharrime", value: "032", provinceCode: 3 },
  { name: "Inhassoro", value: "033", provinceCode: 3 },
  { name: "Jangamo", value: "034", provinceCode: 3 },
  { name: "Mabote", value: "035", provinceCode: 3 },
  { name: "Massinga", value: "036", provinceCode: 3 },
  { name: "Maxixe", value: "037", provinceCode: 3 },
  { name: "Morrumbene", value: "038", provinceCode: 3 },
  { name: "Panda", value: "039", provinceCode: 3 },
  { name: "Vilanculos", value: "040", provinceCode: 3 },
  { name: "Zavala", value: "041", provinceCode: 3 },
  
  // Manica (4)
  { name: "Báruè", value: "042", provinceCode: 4 },
  { name: "Gondola", value: "043", provinceCode: 4 },
  { name: "Guro", value: "044", provinceCode: 4 },
  { name: "Machaze", value: "045", provinceCode: 4 },
  { name: "Macossa", value: "046", provinceCode: 4 },
  { name: "Manica", value: "047", provinceCode: 4 },
  { name: "Mossurize", value: "048", provinceCode: 4 },
  { name: "Sussundenga", value: "049", provinceCode: 4 },
  { name: "Tambara", value: "050", provinceCode: 4 },
  
  // Maputo City (5)
  { name: "Maputo City", value: "051", provinceCode: 5 },
  
  // Maputo (6)
  { name: "Boane", value: "052", provinceCode: 6 },
  { name: "Magude", value: "053", provinceCode: 6 },
  { name: "Manhiça", value: "054", provinceCode: 6 },
  { name: "Marracuene", value: "055", provinceCode: 6 },
  { name: "Matutuíne", value: "056", provinceCode: 6 },
  { name: "Moamba", value: "057", provinceCode: 6 },
  { name: "Namaacha", value: "058", provinceCode: 6 },
  
  // Nampula (7)
  { name: "Angoche", value: "059", provinceCode: 7 },
  { name: "Eráti", value: "060", provinceCode: 7 },
  { name: "Lalaua", value: "061", provinceCode: 7 },
  { name: "Malema", value: "062", provinceCode: 7 },
  { name: "Meconta", value: "063", provinceCode: 7 },
  { name: "Mecubúri", value: "064", provinceCode: 7 },
  { name: "Memba", value: "065", provinceCode: 7 },
  { name: "Mogincual", value: "066", provinceCode: 7 },
  { name: "Mogovolas", value: "067", provinceCode: 7 },
  { name: "Moma", value: "068", provinceCode: 7 },
  { name: "Monapo", value: "069", provinceCode: 7 },
  { name: "Mossuril", value: "070", provinceCode: 7 },
  { name: "Muecate", value: "071", provinceCode: 7 },
  { name: "Murrupula", value: "072", provinceCode: 7 },
  { name: "Nacala-a-Velha", value: "073", provinceCode: 7 },
  { name: "Nacarôa", value: "074", provinceCode: 7 },
  { name: "Nampula", value: "075", provinceCode: 7 },
  { name: "Ribáuè", value: "076", provinceCode: 7 },
  
  // Niassa (8)
  { name: "Cuamba", value: "077", provinceCode: 8 },
  { name: "Lago", value: "078", provinceCode: 8 },
  { name: "Lichinga", value: "079", provinceCode: 8 },
  { name: "Majune", value: "080", provinceCode: 8 },
  { name: "Mandimba", value: "081", provinceCode: 8 },
  { name: "Marrupa", value: "082", provinceCode: 8 },
  { name: "Maúa", value: "083", provinceCode: 8 },
  { name: "Mavago", value: "084", provinceCode: 8 },
  { name: "Mecanhelas", value: "085", provinceCode: 8 },
  { name: "Mecula", value: "086", provinceCode: 8 },
  { name: "Metarica", value: "087", provinceCode: 8 },
  { name: "Muembe", value: "088", provinceCode: 8 },
  { name: "N'gauma", value: "089", provinceCode: 8 },
  { name: "Nipepe", value: "090", provinceCode: 8 },
  { name: "Sanga", value: "091", provinceCode: 8 },
  
  // Sofala (9)
  { name: "Buzi", value: "092", provinceCode: 9 },
  { name: "Caia", value: "093", provinceCode: 9 },
  { name: "Chemba", value: "094", provinceCode: 9 },
  { name: "Cheringoma", value: "095", provinceCode: 9 },
  { name: "Chibabava", value: "096", provinceCode: 9 },
  { name: "Dondo", value: "097", provinceCode: 9 },
  { name: "Gorongosa", value: "098", provinceCode: 9 },
  { name: "Marromeu", value: "099", provinceCode: 9 },
  { name: "Machanga", value: "100", provinceCode: 9 },
  { name: "Maringué", value: "101", provinceCode: 9 },
  { name: "Muanza", value: "102", provinceCode: 9 },
  { name: "Nhamatanda", value: "103", provinceCode: 9 },
  
  // Tete (10)
  { name: "Angónia", value: "104", provinceCode: 10 },
  { name: "Cahora-Bassa", value: "105", provinceCode: 10 },
  { name: "Changara", value: "106", provinceCode: 10 },
  { name: "Chifunde", value: "107", provinceCode: 10 },
  { name: "Chiuta", value: "108", provinceCode: 10 },
  { name: "Doa", value: "109", provinceCode: 10 },
  { name: "Macanga", value: "110", provinceCode: 10 },
  { name: "Magoé", value: "111", provinceCode: 10 },
  { name: "Marávia", value: "112", provinceCode: 10 },
  { name: "Moatize", value: "113", provinceCode: 10 },
  { name: "Mutarara", value: "114", provinceCode: 10 },
  { name: "Tsangano", value: "115", provinceCode: 10 },
  { name: "Zumbo", value: "116", provinceCode: 10 },
  
  // Zambezia (11)
  { name: "Alto Molocue", value: "117", provinceCode: 11 },
  { name: "Chinde", value: "118", provinceCode: 11 },
  { name: "Gilé", value: "119", provinceCode: 11 },
  { name: "Gurué", value: "120", provinceCode: 11 },
  { name: "Ile", value: "121", provinceCode: 11 },
  { name: "Inhassunge", value: "122", provinceCode: 11 },
  { name: "Lugela", value: "123", provinceCode: 11 },
  { name: "Maganja da Costa", value: "124", provinceCode: 11 },
  { name: "Milange", value: "125", provinceCode: 11 },
  { name: "Mocuba", value: "126", provinceCode: 11 },
  { name: "Mopeia", value: "127", provinceCode: 11 },
  { name: "Morrumbala", value: "128", provinceCode: 11 },
  { name: "Namacurra", value: "129", provinceCode: 11 },
  { name: "Namarrói", value: "130", provinceCode: 11 },
  { name: "Nicoadala", value: "131", provinceCode: 11 },
  { name: "Pebane", value: "132", provinceCode: 11 }
];
export const nigeriaRegions = [
  { name: "North Central (NC)", value: 1 },
  { name: "North East (NE)", value: 2 },
  { name: "North West (NW)", value: 3 },
  { name: "South East (SE)", value: 4 },
  { name: "South South (SS)", value: 5 },
  { name: "South West (SW)", value: 6 }
];

export const nigeriaMunicipality = [
  // North Central (1)
  { name: "Benue", value: "001", zoneCode: 1 },
  { name: "Kogi", value: "002", zoneCode: 1 },
  { name: "Kwara", value: "003", zoneCode: 1 },
  { name: "Nasarawa", value: "004", zoneCode: 1 },
  { name: "Niger", value: "005", zoneCode: 1 },
  { name: "Plateau", value: "006", zoneCode: 1 },
  
  // North East (2)
  { name: "Adamawa", value: "007", zoneCode: 2 },
  { name: "Bauchi", value: "008", zoneCode: 2 },
  { name: "Borno", value: "009", zoneCode: 2 },
  { name: "Gombe", value: "010", zoneCode: 2 },
  { name: "Taraba", value: "011", zoneCode: 2 },
  { name: "Yobe", value: "012", zoneCode: 2 },
  
  // North West (3)
  { name: "Jigawa", value: "013", zoneCode: 3 },
  { name: "Kaduna", value: "014", zoneCode: 3 },
  { name: "Kano", value: "015", zoneCode: 3 },
  { name: "Katsina", value: "016", zoneCode: 3 },
  { name: "Kebbi", value: "017", zoneCode: 3 },
  { name: "Sokoto", value: "018", zoneCode: 3 },
  { name: "Zamfara", value: "019", zoneCode: 3 },
  
  // South East (4)
  { name: "Abia State", value: "020", zoneCode: 4 },
  { name: "Anambra State", value: "021", zoneCode: 4 },
  { name: "Ebonyi State", value: "022", zoneCode: 4 },
  { name: "Enugu State", value: "023", zoneCode: 4 },
  { name: "Imo State", value: "024", zoneCode: 4 },
  
  // South South (5)
  { name: "Akwa Ibom", value: "025", zoneCode: 5 },
  { name: "Bayelsa", value: "026", zoneCode: 5 },
  { name: "Cross River", value: "027", zoneCode: 5 },
  { name: "Delta", value: "028", zoneCode: 5 },
  { name: "Edo", value: "029", zoneCode: 5 },
  { name: "Rivers", value: "030", zoneCode: 5 },
  
  // South West (6)
  { name: "Ekiti", value: "031", zoneCode: 6 },
  { name: "Lagos", value: "032", zoneCode: 6 },
  { name: "Ogun", value: "033", zoneCode: 6 },
  { name: "Ondo", value: "034", zoneCode: 6 },
  { name: "Osun", value: "035", zoneCode: 6 },
  { name: "Oyo", value: "036", zoneCode: 6 }
];
// regionData.js

export const senegalRegions = [
  { name: "Dakar", value: "01" },
  { name: "Diourbel", value: "02" },
  { name: "Fatick", value: "03" },
  { name: "Kaffrine", value: "04" },
  { name: "Kaolack", value: "05" },
  { name: "Kedougou", value: "06" },
  { name: "Kolda", value: "07" },
  { name: "Louga", value: "08" },
  { name: "Matam", value: "09" },
  { name: "Saint-Louis", value: "10" },
  { name: "Sedhiou", value: "11" },
  { name: "Tambacounda", value: "12" },
  { name: "Thies", value: "13" },
  { name: "Ziguinchor", value: "14" }
];

export const senegalMunicipality = [
  // Dakar (01)
  { name: "Dakar", value: "001", regionCode: "01" },
  { name: "Guédiawaye", value: "002", regionCode: "01" },
  { name: "Pikine", value: "003", regionCode: "01" },
  { name: "Rufisque", value: "004", regionCode: "01" },
  
  // Diourbel (02)
  { name: "Bambey", value: "005", regionCode: "02" },
  { name: "Diourbel", value: "006", regionCode: "02" },
  { name: "Mbacké", value: "007", regionCode: "02" },
  
  // Fatick (03)
  { name: "Fatick", value: "008", regionCode: "03" },
  { name: "Foundiougne", value: "009", regionCode: "03" },
  { name: "Gossas", value: "010", regionCode: "03" },
  
  // Kaffrine (04)
  { name: "Birkilane", value: "011", regionCode: "04" },
  { name: "Kaffrine", value: "012", regionCode: "04" },
  { name: "Koungheul", value: "013", regionCode: "04" },
  { name: "Malem Hodar", value: "014", regionCode: "04" },
  
  // Kaolack (05)
  { name: "Guinguinéo", value: "015", regionCode: "05" },
  { name: "Kaolack", value: "016", regionCode: "05" },
  { name: "Nioro du Rip", value: "017", regionCode: "05" },
  
  // Kedougou (06)
  { name: "Kédougou", value: "018", regionCode: "06" },
  { name: "Salémata", value: "019", regionCode: "06" },
  { name: "Saraya", value: "020", regionCode: "06" },
  
  // Kolda (07)
  { name: "Kolda", value: "021", regionCode: "07" },
  { name: "Médina Yoro Foulah", value: "022", regionCode: "07" },
  { name: "Vélingara", value: "023", regionCode: "07" },
  
  // Louga (08)
  { name: "Kébémer", value: "024", regionCode: "08" },
  { name: "Linguère", value: "025", regionCode: "08" },
  { name: "Louga", value: "026", regionCode: "08" },
  
  // Matam (09)
  { name: "Kanel", value: "027", regionCode: "09" },
  { name: "Matam", value: "028", regionCode: "09" },
  { name: "Ranérou-Ferlo", value: "029", regionCode: "09" },
  
  // Saint-Louis (10)
  { name: "Dagana", value: "030", regionCode: "10" },
  { name: "Podor", value: "031", regionCode: "10" },
  { name: "Saint-Louis", value: "032", regionCode: "10" },
  
  // Sedhiou (11)
  { name: "Bounkiling", value: "033", regionCode: "11" },
  { name: "Goudomp", value: "034", regionCode: "11" },
  { name: "Sédhiou", value: "035", regionCode: "11" },
  
  // Tambacounda (12)
  { name: "Bakel", value: "036", regionCode: "12" },
  { name: "Goudiry", value: "037", regionCode: "12" },
  { name: "Koumpentoum", value: "038", regionCode: "12" },
  { name: "Tambacounda", value: "039", regionCode: "12" },
  
  // Thies (13)
  { name: "M'bour", value: "040", regionCode: "13" },
  { name: "Thiès", value: "041", regionCode: "13" },
  { name: "Tivaouane", value: "042", regionCode: "13" },
  
  // Ziguinchor (14)
  { name: "Bignona", value: "043", regionCode: "14" },
  { name: "Oussouye", value: "044", regionCode: "14" },
  { name: "Ziguinchor", value: "045", regionCode: "14" }
];
export const BotswanaRegions = [
  { name: "Central", value: "27" },
  { name: "Chobe", value: "67" },
  { name: "Ghanzi", value: "65" },
  { name: "Kgalagadi", value: "69" },
  { name: "Kgatleng", value: "31" },
  { name: "Kweneng", value: "31" },
  { name: "North-East", value: "26" },
  { name: "North-West (Ngamiland)", value: "66" },
  { name: "South-East", value: "24" },
  { name: "Southern", value: "62" }
];

export const BotswanaMunicipality = [
  // Central
  { name: "Bobirwa", value: "001" },
  { name: "Mmadinare", value: "002" },
  { name: "Tonota", value: "003" },
  { name: "Nata-Gweta", value: "004" },
  { name: "Shoshong", value: "005" },
  { name: "Palapye", value: "006" },
  { name: "Serowe North", value: "007" },
  { name: "Serowe South", value: "008" },
  { name: "Serowe West", value: "009" },
  { name: "Boteti East", value: "010" },
  { name: "Boteti West", value: "011" },
  { name: "Mahalapye East", value: "012" },
  { name: "Mahalapye West", value: "013" },
  { name: "Tswapong North", value: "014" },
  { name: "Tswapong South", value: "015" },
  { name: "Chobe", value: "016" },

  // Ghanzi
  { name: "Ghanzi", value: "017" },
  { name: "Charleshill", value: "018" },
  { name: "Ghanzi North", value: "019" },
  { name: "Ghanzi South", value: "020" },

  // Kgalagadi
  { name: "Kgalagadi North", value: "021" },
  { name: "Kgalagadi South", value: "022" },

  // Kgatleng
  { name: "Kgatleng Central", value: "023" },
  { name: "Kgatleng East", value: "024" },
  { name: "Kgatleng West", value: "025" },

  // Kweneng
  { name: "Mogoditshane East", value: "026" },
  { name: "Mogoditshane West", value: "027" },
  { name: "Gabane-Mmankgodi", value: "028" },
  { name: "Thamaga-Kumakwane", value: "029" },
  { name: "Molepolole North", value: "030" },
  { name: "Molepolole South", value: "031" },
  { name: "Lethlakeng-Lephephe", value: "032" },
  { name: "Takatokwane", value: "033" },

  // North-East
  { name: "Francistown East", value: "034" },
  { name: "Francistown South", value: "035" },
  { name: "Francistown West", value: "036" },
  { name: "Tati East", value: "037" },
  { name: "Tati West", value: "038" },
  { name: "Maun East", value: "039" },

  // North-West (Ngamiland)
  { name: "Maun North", value: "040" },
  { name: "Maun West", value: "041" },
  { name: "Ngami", value: "042" },
  { name: "Okavango East", value: "043" },
  { name: "Okavango West", value: "044" },

  // South-East
  { name: "Gaborone Central", value: "045" },
  { name: "Gaborone North", value: "046" },
  { name: "Gaborone South", value: "047" },
  { name: "Gaborone Bonnington", value: "048" },
  { name: "Gaborone Bonnington", value: "049" },
  { name: "Tlokweng", value: "050" },
  { name: "Ramotswa", value: "051" },
  { name: "Lobatse", value: "052" },

  // Southern
  { name: "Moshupa-Manyana", value: "053" },
  { name: "Kanye East", value: "054" },
  { name: "Kanye West", value: "055" },
  { name: "Goodhope-Mmathethe", value: "056" },
  { name: "Jwaneng-Mabutsane", value: "057" },
  { name: "Ghanzi North", value: "058" },
  { name: "Ghanzi South", value: "059" }
];
